var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _path, _g, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _path2, _path3, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpriteIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "asterisk",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,32c17.7,0,32,14.3,32,32v135.5l111.5-66.9c15.2-9.1,34.8-4.2,43.9,11s4.2,34.8-11,43.9L318.2,256l114.3,68.6 c15.2,9.1,20.1,28.7,11,43.9s-28.7,20.1-43.9,11l-111.6-67V448c0,17.7-14.3,32-32,32s-32-14.3-32-32V312.5l-111.5,66.9 c-15.2,9.1-34.8,4.2-43.9-11s-4.2-34.8,11-43.9L193.8,256L79.5,187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1,43.9-11l111.6,67V64 C224,46.3,238.3,32,256,32z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "camera",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,88l-9.1,27.4H87.2c-31,0-56.2,25.2-56.2,56.2v225c0,31,25.2,56.2,56.2,56.2h337.5c31,0,56.2-25.2,56.2-56.2v-225 c0-31-25.2-56.2-56.2-56.2h-65.7L350,88c-5.7-17.2-21.8-28.8-40-28.8H202C183.8,59.1,167.8,70.7,162,88z M256,199.8 c46.6,0,84.4,37.8,84.4,84.4s-37.8,84.4-84.4,84.4s-84.4-37.8-84.4-84.4S209.4,199.8,256,199.8z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "card",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.7,474.2H123.2c-11,0-20-9-20-20V57.7c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C408.7,465.3,399.8,474.2,388.7,474.2z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "card-line",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.2,493.8H122.8c-22.1,0-40-17.9-40-40V57.2c0-22.1,17.9-40,40-40h265.5c22.1,0,40,17.9,40,40v396.5 C428.2,475.8,410.3,493.8,388.2,493.8z M122.8,453.7C122.8,453.7,122.8,453.8,122.8,453.7l265.5,0l0-396.5c0,0,0,0-0.1,0l-265.4,0 c0,0,0,0,0,0.1L122.8,453.7C122.8,453.7,122.8,453.7,122.8,453.7z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.6,105.3c12.5,12.5,12.5,32.8,0,45.3l-256,256c-12.5,12.5-32.8,12.5-45.3,0l-128-128c-12.5-12.5-12.5-32.8,0-45.3 s32.8-12.5,45.3,0L192,338.6l233.4-233.3C437.9,92.8,458.2,92.8,470.6,105.3L470.6,105.3z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,472.5c119.6,0,216.5-96.9,216.5-216.5S375.6,39.5,256,39.5S39.5,136.4,39.5,256S136.4,472.5,256,472.5z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-check",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.8,256c0,113.1-91.7,204.8-204.8,204.8c-113.1,0-204.8-91.7-204.8-204.8c0-113.1,91.7-204.8,204.8-204.8 C369.1,51.2,460.8,142.9,460.8,256z M512,256c0,141.4-114.6,256-256,256C114.6,512,0,397.4,0,256C0,114.6,114.6,0,256,0 C397.4,0,512,114.6,512,256z M217.6,356.2l146.1-146.1l-36.2-36.2L217.6,283.8l-45.9-45.9l-36.2,36.2L217.6,356.2z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-line",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,492.5c-63.2,0-122.6-24.6-167.2-69.3C44.1,378.6,19.5,319.2,19.5,256c0-63.2,24.6-122.6,69.3-167.2 S192.8,19.5,256,19.5c63.2,0,122.6,24.6,167.2,69.3c44.7,44.7,69.3,104.1,69.3,167.2c0,63.2-24.6,122.6-69.3,167.2 C378.6,467.9,319.2,492.5,256,492.5z M256,59.5C147.6,59.5,59.5,147.6,59.5,256S147.6,452.5,256,452.5S452.5,364.4,452.5,256 S364.4,59.5,256,59.5z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-minus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,472.5c119.6,0,216.5-96.9,216.5-216.5S375.6,39.5,256,39.5S39.5,136.4,39.5,256S136.4,472.5,256,472.5z M195.1,235.7 h121.8c11.2,0,20.3,9,20.3,20.3c0,11.2-9,20.3-20.3,20.3H195.1c-11.2,0-20.3-9-20.3-20.3C174.8,244.8,183.9,235.7,195.1,235.7z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-plus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,472.5c119.5,0,216.5-97,216.5-216.5S375.5,39.5,256,39.5S39.5,136.5,39.5,256S136.5,472.5,256,472.5z M235.7,330.5 v-54.1h-54.1c-11.2,0-20.3-9.1-20.3-20.3c0-11.2,9.1-20.3,20.3-20.3h54.1v-54.1c0-11.2,9.1-20.3,20.3-20.3 c11.2,0,20.3,9.1,20.3,20.3v54.1h54.1c11.2,0,20.3,9.1,20.3,20.3c0,11.2-9.1,20.3-20.3,20.3h-54.1v54.1c0,11.2-9.1,20.3-20.3,20.3 C244.8,350.7,235.7,341.7,235.7,330.5z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "doble-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4,233.4c-12.5,12.5-12.5,32.8,0,45.3l160,160c12.5,12.5,32.8,12.5,45.3,0c12.5-12.5,12.5-32.8,0-45.3L125.3,256 l137.3-137.4c12.5-12.5,12.5-32.8,0-45.3s-32.8-12.5-45.3,0L57.4,233.4L57.4,233.4z M409.4,73.4l-160,160 c-12.5,12.5-12.5,32.8,0,45.3l160,160c12.5,12.5,32.8,12.5,45.3,0s12.5-32.8,0-45.3L317.2,256l137.3-137.4 c12.5-12.5,12.5-32.8,0-45.3S421.8,60.8,409.4,73.4L409.4,73.4z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "doble-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.6,278.6c12.5-12.5,12.5-32.8,0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3,0c-12.5,12.5-12.5,32.8,0,45.3L386.8,256 L249.4,393.4c-12.5,12.5-12.5,32.8,0,45.3s32.8,12.5,45.3,0L454.6,278.6L454.6,278.6z M102.6,438.6l160-160 c12.5-12.5,12.5-32.8,0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3,0s-12.5,32.8,0,45.3L194.7,256L57.4,393.4 c-12.5,12.5-12.5,32.8,0,45.3S90.2,451.2,102.6,438.6L102.6,438.6z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "double-triangle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,66.7c5.6,0,10.7,2.9,13.5,7.8l84.6,144.1c2.9,4.9,2.9,10.8,0.1,15.7s-8,7.9-13.6,7.9H171.4c-5.6,0-10.8-3-13.6-7.9 s-2.7-10.9,0.1-15.7l84.6-144.1C245.3,69.6,250.4,66.7,256,66.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.5,456.2c-5.6,0-10.7-2.9-13.5-7.8l-84.6-144.1c-2.9-4.9-2.9-10.8-0.1-15.7s8-7.9,13.6-7.9h169.2 c5.6,0,10.8,3,13.6,7.9c2.8,4.9,2.7,10.9-0.1,15.7L269,448.5C266.2,453.4,261.1,456.2,255.5,456.2z"
  }))))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "down",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.6,374.6c-12.5,12.5-32.8,12.5-45.3,0l-192-192c-12.5-12.5-12.5-32.8,0-45.3s32.8-12.5,45.3,0L256,306.7l169.4-169.3 c12.5-12.5,32.8-12.5,45.3,0s12.5,32.8,0,45.3L278.6,374.6L278.6,374.6z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "feather",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M82.9,313.8L54.6,342c-32,32-32.9,83-2.1,116.2c0.4,0.4,0.7,0.8,1.1,1.1c15.5,14.5,35.8,22.4,57,22.4 c22.3,0,43.3-8.7,59.1-24.5l28.3-28.3l159.2-65.1c0.1,0,0.1-0.1,0.2-0.1l84.9-34.7c27.3-11.2,36.2-29.2,38.8-42.4 c4.2-21-4.9-45.2-24.4-64.7c-16.1-16.1-38.9-24.3-62.7-23.9c1.8-20.9-5-42.4-20.3-59c-0.4-0.4-0.8-0.8-1.2-1.2 c-16.6-15.4-38.1-22.1-59-20.3c0.4-23.8-7.8-46.6-23.9-62.7c-16.3-16.4-35.9-25.4-54.2-25.4c-3.5,0-7,0.3-10.4,1 c-13.2,2.7-31.2,11.5-42.4,38.9L148,154.2c0,0.1,0,0.1-0.1,0.2L82.9,313.8z M195,382.2l91.4-70.2l23.3,23.3L195,382.2z M160,353.1 l-1.4-1.4l72.8-94.8l23.4,23.4L160,353.1z M130,315.9L176.4,202l23.2,23.2L130,315.9z M138.4,425.8c-7.4,7.4-17.2,11.5-27.7,11.5 c-9.7,0-19-3.5-26.1-10c-13.9-15.5-13.3-39,1.5-53.9l15.7-15.7l52.4,52.4L138.4,425.8z M425.5,253.4c9.8,9.8,13.2,19.6,12.2,24.5 c-1,4.8-8,8.4-12.1,10L354.3,317l-32.4-32.4l45.9-35.3C388.5,238.9,412.6,240.5,425.5,253.4z M341.8,169.9 c11.2,12.8,10.8,31.8-0.8,44.2l-50.7,39l-31.7-31.7l39-50.7C310,159,329,158.7,341.8,169.9z M223.7,86.1c1.7-4.1,5.2-11.1,10-12.1 c4.9-1,14.7,2.4,24.5,12.2c12.9,12.9,14.5,36.9,4,57.6l-35.3,45.9l-32.3-32.3L223.7,86.1z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-pdf",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,85.7c0-31.3,25.5-56.8,56.8-56.8h141.9v113.5c0,15.7,12.7,28.4,28.4,28.4h113.5v127.7H192.1 c-31.3,0-56.8,25.5-56.8,56.8v127.7H92.8c-31.3,0-56.8-25.5-56.8-56.8V85.7z M376.6,142.5H263.1V28.9L376.6,142.5z M192.1,341.2 h28.4c27.4,0,49.7,22.3,49.7,49.7s-22.3,49.7-49.7,49.7h-14.2v28.4c0,7.8-6.4,14.2-14.2,14.2c-7.8,0-14.2-6.4-14.2-14.2v-42.6v-71 C177.9,347.5,184.3,341.2,192.1,341.2z M220.5,412.1c11.8,0,21.3-9.5,21.3-21.3s-9.5-21.3-21.3-21.3h-14.2v42.6H220.5z M305.7,341.2 h28.4c23.5,0,42.6,19.1,42.6,42.6v56.8c0,23.5-19.1,42.6-42.6,42.6h-28.4c-7.8,0-14.2-6.4-14.2-14.2V355.3 C291.5,347.5,297.9,341.2,305.7,341.2z M334.1,454.7c7.8,0,14.2-6.4,14.2-14.2v-56.8c0-7.8-6.4-14.2-14.2-14.2h-14.2v85.2H334.1z  M405,355.3c0-7.8,6.4-14.2,14.2-14.2h42.6c7.8,0,14.2,6.4,14.2,14.2s-6.4,14.2-14.2,14.2h-28.4v28.4h28.4c7.8,0,14.2,6.4,14.2,14.2 c0,7.8-6.4,14.2-14.2,14.2h-28.4v42.6c0,7.8-6.4,14.2-14.2,14.2c-7.8,0-14.2-6.4-14.2-14.2v-56.8V355.3z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "futbol",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.7,345.5l-61.6-4.2c-4.5-0.3-8.8,1-12.4,3.6c-3.6,2.7-6.2,6.4-7.3,10.7l-15.1,59.8c-13.5,3.6-27.7,5.5-42.3,5.5 s-28.8-1.9-42.3-5.5l-15.1-59.8c-1.1-4.3-3.7-8-7.3-10.7c-3.6-2.7-7.9-3.9-12.4-3.6l-61.6,4.2c-15.1-23.3-24.5-50.9-26.1-80.5 l52.1-32.9c3.8-2.4,6.6-6.1,7.9-10.2c1.4-4.2,1.2-8.7-0.4-12.9L128,151.8c18.1-22,41.5-39.3,68.5-49.8l47.5,39.5 c3.5,2.9,7.7,4.4,12.1,4.4c4.4,0,8.7-1.6,12.1-4.4l47.4-39.5c26.9,10.4,50.5,27.7,68.4,49.8L361.1,209c-1.6,4.2-1.8,8.6-0.4,12.9 c1.4,4.2,4.2,7.8,7.9,10.2l52.1,32.9C419,294.5,409.7,322,394.7,345.5L394.7,345.5z M256,476c121.5,0,220-98.5,220-220 S377.5,36,256,36S36,134.5,36,256S134.5,476,256,476z M268.1,196.1c-7.3-5.3-17-5.3-24.2,0l-41.1,29.8c-7.3,5.3-10.2,14.5-7.4,23 l15.7,48.4c2.8,8.5,10.6,14.3,19.6,14.3h50.9c8.9,0,16.9-5.8,19.6-14.3l15.7-48.4c2.8-8.5-0.3-17.8-7.4-23L268.1,196.1L268.1,196.1z "
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR_PH",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.8,236.1h-50.7L377,412.8h-28.6l-26.6-176.7H170.7l-26.6,175h-27.9l26.2-175L97.5,235c0,0-18.7-0.5-18.4-17.3 c0.5-21.8,0-54.8,0-54.8s-0.8-24.2,21.1-24.2h49.4V99.9h27.2v37.4h115.1V99.9h28.6v37.8h41.9l70.5,38.5v36.4 C432.8,212.6,435.2,238.1,400.8,236.1z",
    fill: "#030104"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR_BB",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#030104",
    points: "48.5,159.4 462.1,159.4 462.1,190 392.6,190 432.5,349.9 416.6,349.9 375.3,190.5 133.7,190.5  94.4,347.8 76.5,347.8 117.4,190.5 48.5,190.5 "
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR-FX",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 150.9,
    fill: "#030104",
    width: 217,
    height: 209
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030104",
    d: "M106.2,106.9v297h297v-297H106.2z M383.4,384.2H125.9V126.7h257.5V384.2z"
  })))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR-HB",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#030104",
    points: "91.8,154.1 91.8,386.9 79.5,386.9 79.5,154.1 63.2,154.1 63.2,124.1 447,124.1 447,154.1 432.7,154.1  432.7,387 422,387 422,154.6 "
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR-PB",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#030104",
    points: "124.7,238.3 124.7,365 113.9,365 113.9,238.3 98.1,238.3 98.1,207.1 466.4,207.1 466.4,238.3  452.6,238.3 452.6,365 440.6,365 440.6,237.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#030104",
    points: "73.5,172 73.5,367.8 61.2,367.8 61.2,172 44.9,172 44.9,142 413.7,142 413.7,172 400.4,172  400.4,193.9 388.7,193.9 388.7,172.5  "
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR-SR",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.2,202.5c-3.9,0-7.8,0.3-11.6,0.9v1.3h23.1v-1.3C162,202.8,158.1,202.5,154.2,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,203.4v1.3h-23.1v-1.3c-45.2,6.7-80.2,52.6-80.2,108.1c0,60.2,41.1,109,91.8,109s91.8-48.8,91.8-109 C246,256,211,210.2,165.8,203.4z M154.2,392.1c-34,0-61.5-36.1-61.5-80.5c0-44.5,27.5-80.5,61.5-80.5c34,0,61.5,36,61.5,80.5 C215.7,356,188.2,392.1,154.2,392.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,173.3v30.1c-3.8-0.6-7.6-0.9-11.6-0.9c-3.9,0-7.8,0.3-11.6,0.9v-30.1H165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,203.4v1.3h-23.1v-1.3c3.8-0.6,7.6-0.9,11.6-0.9C158.1,202.5,162,202.8,165.8,203.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 85.5,
    width: 12.8,
    height: 87.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,137.2c-50.7,0-91.8,48.8-91.8,109s41.1,109,91.8,109s91.8-48.8,91.8-109S415.8,137.2,365.1,137.2z M365.1,327.1 c-34,0-61.5-36.2-61.5-80.9s27.5-80.9,61.5-80.9c34,0,61.5,36.2,61.5,80.9S399.1,327.1,365.1,327.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.2,
    y: 115.6,
    width: 27.7,
    height: 23.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 86.5,
    width: 10.5,
    height: 29.2
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR-UB",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#030104",
    points: "133.8,293.8 133.8,397.5 123,397.5 123,293.8 107.2,293.8 107.2,269.6 459.5,269.6 459.5,293.8  442.7,293.8 442.7,397.5 430.7,397.5 430.7,293.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 307.3,
    fill: "#030104",
    width: 10.7,
    height: 90.1
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#030104",
    points: "82.2,142.7 82.2,397.5 69.9,397.5 69.9,142.7 53.6,142.7 53.6,119.7 406.4,119.7 406.4,142.7  390.1,142.7 390.1,258.6 379.4,258.6 379.4,143.2  "
  })))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "GAR-VT",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#030104",
    d: "M358.4,400.3H120.7v-28.6h84.3V138.8h-73v-29.1h186.4c0,0,36.7,3.9,54.6,24c21.2,23.7,15.8,71.5,15.8,71.5h-22 l-0.3-27.7c-1.2-13.4-8.5-21.6-14.6-27.1c-5-4.5-12.1-9.5-26.9-12.1h-55.7v232.3h89.4L358.4,400.3z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "horse",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,429.7v-127c0-93.6,59-177.1,147.2-208.3l146.5-51.9c18.5-6.6,37.8,7.2,37.8,26.7c0,9.5-4.8,18.3-12.6,23.6l-28.8,19.2 c41.6,0,78.7,25.8,93.3,64.6l41.9,111.8c10.2,27.1,3.5,57.7-17,78.1c-13.8,13.8-32.7,21.6-52.2,21.6h-3c-22.5,0-44-10.1-58.3-27.4 L308,327.4c-10.1,3.5-20.9,5.6-32.2,5.6h-0.1l0,0c-5.5,0-10.8-0.5-16.1-1.3c-3.1-0.5-6.2-1.2-9.2-2l0,0c-24.9-6.7-45.9-23.2-58.5-45 c-3.8-6.6-12.3-8.9-18.9-5c-6.6,3.9-8.9,12.3-5,18.9c20.7,35.8,59,60.4,103,62.1l40.7,61.1c3.4,5.3,5.4,11.4,5.4,17.6 c0,17.5-14.3,31.8-31.8,31.8H82.5C59.6,471.1,41,452.5,41,429.7L41,429.7z M324.1,222.5c11.5,0,20.7-9.2,20.7-20.7 c0-11.5-9.2-20.7-20.7-20.7s-20.7,9.2-20.7,20.7C303.4,213.3,312.6,222.5,324.1,222.5z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "language",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.4,126.1c0-0.2,0-0.3-0.1-0.5c-0.6-0.8-1.2-1.5-1.8-2.3c-4.1-5.7-8.7-11.2-13.4-16.5c-1.3-1.4-2.5-2.9-3.9-4.3 c-4.8-5.2-9.9-10.1-15.2-14.8c-0.9-0.8-1.9-1.8-2.9-2.6c-13.2-11.2-27.5-20.9-42.7-28.8c-0.6-0.3-1.2-0.6-1.9-0.9 c-6.8-3.5-13.8-6.6-20.9-9.3c-1.6-0.6-3.1-1.1-4.6-1.6c-6.3-2.3-12.8-4.2-19.3-6c-1.9-0.5-3.9-1-5.8-1.5c-6.4-1.5-12.9-2.6-19.4-3.6 c-2-0.3-4-0.7-5.9-0.9c-17-2.1-34.1-2.1-51,0c-2,0.3-4,0.7-5.9,0.9c-6.6,0.9-13.1,2.1-19.4,3.6c-2,0.5-3.9,0.9-5.8,1.5 c-6.5,1.7-13,3.7-19.3,6c-1.6,0.6-3.1,1.1-4.6,1.6c-7.2,2.7-14.1,5.8-20.9,9.3c-0.7,0.3-1.2,0.6-1.9,0.9 c-15.4,7.9-29.7,17.6-42.8,28.8c-0.9,0.8-1.9,1.8-2.9,2.6c-5.3,4.7-10.4,9.6-15.2,14.8c-1.3,1.4-2.6,2.8-3.9,4.3 c-4.7,5.3-9.1,10.8-13.4,16.5c-0.6,0.8-1.2,1.5-1.8,2.3c-0.1,0.1-0.1,0.3-0.2,0.5c-55.5,77.7-55.5,182.1,0,259.8 c0.1,0.2,0.1,0.3,0.2,0.5c0.6,0.8,1.2,1.5,1.8,2.3c4.1,5.7,8.7,11.2,13.4,16.5c1.3,1.4,2.5,2.9,3.9,4.3c4.8,5.2,9.9,10.1,15.2,14.8 c0.9,0.8,1.9,1.8,2.9,2.6c13.1,11.2,27.4,20.9,42.7,28.8c0.6,0.3,1.2,0.6,1.9,0.9c6.8,3.5,13.8,6.6,20.9,9.3 c1.6,0.6,3.1,1.1,4.6,1.6c6.3,2.3,12.8,4.2,19.3,6c1.9,0.5,3.9,1,5.8,1.5c6.4,1.5,12.9,2.6,19.4,3.6c2,0.3,4,0.7,5.9,0.9 c17,2.1,34.1,2.1,51,0c2-0.3,4-0.7,5.9-0.9c6.6-0.9,13.1-2.1,19.4-3.6c2-0.5,3.9-0.9,5.8-1.5c6.5-1.7,13-3.7,19.3-6 c1.6-0.6,3.1-1.1,4.6-1.6c7.2-2.7,14.1-5.8,20.9-9.3c0.7-0.3,1.2-0.6,1.9-0.9c15.3-7.9,29.6-17.6,42.7-28.8c0.9-0.8,1.9-1.8,2.9-2.6 c5.3-4.7,10.4-9.6,15.2-14.8c1.3-1.4,2.6-2.8,3.9-4.3c4.7-5.3,9.1-10.8,13.4-16.5c0.6-0.8,1.2-1.5,1.8-2.3c0.1-0.1,0.1-0.3,0.2-0.5 C494.9,308.1,494.9,203.7,439.4,126.1z M421,156.4c15.4,25.3,24.7,53.9,27.1,83.4h-96.3c-1.2-19.1-4.2-38.2-9-56.7 C370,178,396.4,169,421,156.4L421,156.4z M296.9,67.4c0.9,0.2,1.8,0.5,2.6,0.8c5.7,1.3,11.5,2.9,17.1,4.8c0.8,0.3,1.7,0.7,2.5,0.9 c5.6,1.9,10.9,4.1,16.3,6.4c0.9,0.5,1.9,0.9,2.8,1.3c5.1,2.4,10.1,5.1,15,7.9l3.2,2c4.6,2.8,9.1,5.8,13.5,9c1.1,0.8,2.3,1.6,3.4,2.5 c4.3,3.2,8.4,6.7,12.3,10.4c1,0.9,2.1,1.9,3.1,2.8c4.1,3.9,8,8,11.9,12.3c0.5,0.6,1,1,1.5,1.6c-21.8,10.4-44.8,17.8-68.6,22 c-11-30.2-25.5-59.1-43.2-85.9C292.5,66.7,294.8,66.9,296.9,67.4z M192.4,239.9c1.2-17.4,4.2-34.7,8.9-51.4 c18.2,2.2,36.6,3.2,54.9,3.2s36.7-1.1,54.9-3.3c4.6,16.9,7.5,34.1,8.8,51.5L192.4,239.9L192.4,239.9z M319.8,272 c-1.2,17.4-4.2,34.7-8.9,51.4c-18.2-2.2-36.6-3.2-54.9-3.2s-36.7,1-54.9,3.2c-4.6-16.9-7.5-34-8.8-51.4H319.8L319.8,272z M256,73.5 c18.3,25.9,33.4,54,44.8,83.6c-14.9,1.6-29.9,2.4-44.8,2.4s-29.9-0.8-44.8-2.4C222.8,127.5,237.8,99.4,256,73.5L256,73.5z  M111.5,128.5c3.8-4.2,7.7-8.4,11.9-12.3c1-0.9,2.1-1.9,3.1-2.8c4-3.6,8.1-7.1,12.3-10.4c1.1-0.8,2.3-1.6,3.4-2.5 c4.3-3.2,8.9-6.2,13.5-9l3.2-2c4.9-2.8,9.9-5.5,15-7.9c0.9-0.5,1.9-0.9,2.8-1.3c5.4-2.4,10.7-4.5,16.3-6.4c0.8-0.3,1.6-0.7,2.5-0.9 c5.6-1.9,11.2-3.4,17.1-4.8c0.9-0.2,1.8-0.5,2.7-0.7c2.2-0.5,4.5-0.8,6.7-1.1c-17.8,26.9-32.3,55.7-43.3,85.9 c-23.7-4.2-46.8-11.7-68.6-22C110.5,129.7,111.1,129.1,111.5,128.5z M91.1,156.4c24.7,12.6,51,21.6,78.2,26.7 c-4.8,18.6-7.8,37.6-9,56.7H64C66.4,210.3,75.6,181.8,91.1,156.4L91.1,156.4z M91.1,355.4C75.7,330.1,66.4,301.5,64,272h96.3 c1.2,19.1,4.2,38.2,9,56.7C142.1,333.8,115.7,342.9,91.1,355.4z M215.2,444.4c-0.9-0.2-1.8-0.5-2.6-0.8c-5.7-1.3-11.5-2.9-17.1-4.8 c-0.8-0.3-1.7-0.7-2.5-0.9c-5.6-1.9-10.9-4.1-16.3-6.4c-0.9-0.5-1.9-0.9-2.8-1.3c-5.1-2.4-10.1-5.1-15-7.9l-3.2-2 c-4.6-2.8-9.1-5.8-13.5-9c-1.1-0.8-2.3-1.6-3.4-2.5c-4.3-3.2-8.4-6.7-12.3-10.4c-1-0.9-2.1-1.9-3.1-2.8c-4.1-3.9-8-8-11.9-12.3 c-0.5-0.6-1-1-1.5-1.6c21.8-10.4,44.8-17.8,68.6-22c11,30.2,25.5,59.1,43.2,85.9C219.7,445.2,217.3,444.9,215.2,444.4L215.2,444.4z  M256,438.4c-18.3-25.9-33.4-54-44.8-83.6c29.8-3.2,59.8-3.2,89.6,0l0,0C289.3,384.4,274.3,412.5,256,438.4z M400.6,383.3 c-3.8,4.2-7.7,8.4-11.9,12.3c-1,0.9-2.1,1.9-3.1,2.8c-4,3.6-8.1,7.1-12.3,10.4c-1.1,0.8-2.3,1.7-3.4,2.5c-4.3,3.2-8.9,6.2-13.5,9 l-3.2,2c-4.9,2.8-9.9,5.5-15,7.9c-0.9,0.5-1.9,0.9-2.8,1.3c-5.4,2.4-10.7,4.5-16.3,6.4c-0.8,0.3-1.6,0.7-2.5,0.9 c-5.6,1.9-11.2,3.4-17.1,4.8c-0.9,0.2-1.8,0.5-2.7,0.7c-2.2,0.5-4.5,0.8-6.7,1.1c17.7-26.9,32.3-55.7,43.2-85.9 c23.7,4.2,46.8,11.7,68.6,22C401.6,382.2,401.1,382.7,400.6,383.3L400.6,383.3z M421,355.4c-24.7-12.6-51-21.6-78.2-26.7 c4.8-18.6,7.8-37.6,9-56.7H448C445.7,301.5,436.5,330.1,421,355.4z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.4,233.4c-12.5,12.5-12.5,32.8,0,45.3l192,192c12.5,12.5,32.8,12.5,45.3,0s12.5-32.8,0-45.3L205.3,256L374.6,86.6 c12.5-12.5,12.5-32.8,0-45.3s-32.8-12.5-45.3,0L137.4,233.4L137.4,233.4z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowLeft2",
    viewBox: "0 0 32 33"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.635 6.98438L10.69 7.01938L5.00466 15.9844L30 15.9844L30 17.9844L5.02785 17.9844L10.75 26.9494L10.69 26.9844L8.39 26.9844L2 16.9744L8.335 6.98438L10.635 6.98438Z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowRight2",
    viewBox: "0 0 32 33"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.365 26.9844L21.31 26.9494L26.9953 17.9844H2V15.9844H26.9722L21.25 7.01937L21.31 6.98438H23.61L30 16.9944L23.665 26.9844H21.365Z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowLeft",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,50l22,31.5h16.3L29.4,57.1L92,57.7V42.3l-62.4,0.6l16.7-24.4H30L8,50z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowRight",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92,50L70,18.5H53.7l16.9,24.4L8,42.3v15.4l62.4-0.6L53.7,81.5H70L92,50z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowDown",
    viewBox: "0 0 32 33"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 22.3494L6.035 22.2944L15 27.9797L15 2.98437L17 2.98437L17 27.9565L25.965 22.2344L26 22.2944L26 24.5944L15.99 30.9844L6 24.6494L6 22.3494Z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowRight",
    viewBox: "0 0 32 33"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 11.6194L25.965 11.6744L17 5.98903L17 30.9844L15 30.9844L15 6.01222L6.035 11.7344L6 11.6744L6 9.37437L16.01 2.98438L26 9.31937L26 11.6194Z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "location",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.6,478.1c46.7-58.5,153.3-200.2,153.3-279.7c0-96.5-78.3-174.8-174.8-174.8S81.2,101.8,81.2,198.3 c0,79.6,106.5,221.3,153.3,279.7C245.6,492,266.4,492,277.6,478.1L277.6,478.1z M256,140c32.1,0,58.3,26.1,58.3,58.3 s-26.1,58.3-58.3,58.3s-58.3-26.1-58.3-58.3S223.8,140,256,140z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "maximize",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,32H56c-13.3,0-24,10.7-24,24v144c0,9.7,5.8,18.5,14.8,22.2s19.3,1.7,26.2-5.2l40-40l79,79l-79,79l-40-40 c-6.9-6.9-17.2-8.9-26.2-5.2S32,302.3,32,312v144c0,13.3,10.7,24,24,24h144c9.7,0,18.5-5.8,22.2-14.8s1.7-19.3-5.2-26.2l-40-40 l79-79l79,79l-40,40c-6.9,6.9-8.9,17.2-5.2,26.2S302.3,480,312,480h144c13.3,0,24-10.7,24-24V312c0-9.7-5.8-18.5-14.8-22.2 s-19.3-1.7-26.2,5.2l-40,40l-79-79l79-79l40,40c6.9,6.9,17.2,8.9,26.2,5.2S480,209.7,480,200V56c0-13.3-10.7-24-24-24H312 c-9.7,0-18.5,5.8-22.2,14.8S288.1,66.1,295,73l40,40l-79,79l-79-79l40-40c6.9-6.9,8.9-17.2,5.2-26.2S209.7,32,200,32z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "WRS-medal",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1,31h112.5c4.7,0,9.1,2.3,11.6,6.3l71.3,106.8c-43.5,3.6-82.7,22.5-112.1,51.3L33.4,52.9c-2.9-4.3-3.1-9.9-0.7-14.4 S39.9,31,45.1,31z M478.6,52.9l-95,142.5c-29.4-28.8-68.7-47.6-112.1-51.3l71.3-106.9c2.6-3.9,7-6.3,11.6-6.3H467 c5.2,0,10,2.8,12.4,7.4C481.8,43.1,481.5,48.6,478.6,52.9L478.6,52.9z M410.7,326.3c0,85.4-69.3,154.7-154.7,154.7 s-154.7-69.3-154.7-154.7S170.6,171.7,256,171.7S410.7,240.8,410.7,326.3z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "medal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size=32px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.995 2H6V3.045L10.8404 11.431C7.93914 13.181 6 16.363 6 20C6 25.525 10.475 30 16 30C21.525 30 26 25.525 26 20C26 16.363 24.0609 13.181 21.1596 11.431L26 3.045V2H24.305L19.3539 10.5758C18.5972 10.3066 17.7984 10.126 16.9699 10.0464L13.4805 4H20.84L21.995 2ZM8.86 4H11.1746L11.1721 4.00142L14.6835 10.0858C13.9824 10.1779 13.3042 10.3426 12.6567 10.572L8.86 4Z"
  }))))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "medal2",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010202;",
    d: "M256,421.8c-56.7,0-102.3-46.1-102.3-102.3c0-56.7,46.1-102.3,102.3-102.3c56.7,0,102.3,46.1,102.3,102.3 C358.2,376.2,312.6,421.8,256,421.8z M256,243.7c-42,0-75.8,34.2-75.8,75.8s34.2,75.8,75.8,75.8c42,0,75.8-34.2,75.8-75.8 S298,243.7,256,243.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202;",
    d: "M256,478.5c-87.6,0-159-71.4-159-159s71.4-159,159-159s158.9,71.4,158.9,159S343.6,478.5,256,478.5z  M256,187.2c-72.9,0-132.5,59.5-132.5,132.5S183.1,452.1,256,452.1s132.5-59.5,132.5-132.5C388.4,246.6,328.9,187.2,256,187.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010202;",
    points: "166.7,203.4 72.2,33.5 211.2,33.5 251.5,117.9 295.9,33.5 439.8,33.5 343.6,199.3 320.4,185.9  393.8,60 311.8,60 250.7,177.3 194.5,60 117,60 189.9,190.8  "
  })))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "menu",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,95.3c0-17.8,14.4-32.1,32.1-32.1h385.7c17.8,0,32.1,14.4,32.1,32.1s-14.4,32.1-32.1,32.1H63.1 C45.4,127.4,31,113.1,31,95.3z M31,256c0-17.8,14.4-32.1,32.1-32.1h385.7c17.8,0,32.1,14.4,32.1,32.1s-14.4,32.1-32.1,32.1H63.1 C45.4,288.1,31,273.8,31,256z M481,416.7c0,17.8-14.4,32.1-32.1,32.1H63.1c-17.8,0-32.1-14.4-32.1-32.1c0-17.8,14.4-32.1,32.1-32.1 h385.7C466.6,384.6,481,398.9,481,416.7z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "minimize",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.7,227.9H305.1c-11.7,0-21.1-9.4-21.1-21.1V80.3c0-8.6,5.1-16.2,13-19.5c7.9-3.2,16.9-1.5,23,4.5l35.1,35.1l64.4-64.4 c3.2-3.2,7.6-5,12-5c4.5,0,8.8,1.8,12,5l32.3,32.3c3.1,3.1,4.9,7.5,4.9,11.9c0,4.4-1.8,8.8-5,12l-64.4,64.4l35.1,35.1 c6.1,6.1,7.8,15.2,4.5,23C447.9,222.8,440.2,227.9,431.7,227.9z M431.7,284.1c8.6,0,16.2,5.1,19.5,13s1.5,16.9-4.5,23l-35.1,35.1 l64.5,64.5c3.1,3.1,5,7.5,5,12s-1.8,8.8-5,12l-32.3,32.3c-3.2,3.1-7.6,4.8-12,4.8c-4.5,0-8.8-1.8-12-5l-64.5-64.4l-35.1,35.1 c-6.1,6.1-15.2,7.8-23,4.5c-7.9-3.2-13-11-13-19.5V305.2c0-11.7,9.4-21.1,21.1-21.1H431.7z M206.8,284.1c11.7,0,21.1,9.4,21.1,21.1 v126.5c0,8.6-5.1,16.2-13,19.5c-7.9,3.2-16.9,1.5-23-4.5l-35.1-35.1l-64.4,64.4c-3.2,3.2-7.6,5-12,5c-4.4,0-8.8-1.8-12-5l-32.2-32.2 c-3.2-3.2-5-7.6-5-12s1.8-8.8,5-12l64.4-64.4l-35.1-35.1c-6.1-6.1-7.8-15.2-4.5-23c3.2-7.9,11-13,19.5-13L206.8,284.1L206.8,284.1z  M80.2,227.9c-8.6,0-16.2-5.1-19.5-13c-3.2-7.9-1.5-16.9,4.5-23l35.2-35.1L36,92.3c-3.2-3.2-5-7.6-5-12c0-4.4,1.8-8.8,5-12 l32.2-32.2c3.2-3.2,7.6-5,12-5c4.4,0,8.8,1.8,12,5l64.5,64.4l35.1-35.1c6.1-6.1,15.2-7.8,23-4.5c7.9,3.2,13,11,13,19.5v126.5 c0,11.7-9.4,21.1-21.1,21.1H80.2z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464,256c0,17.7-14.3,32-32,32H80c-17.7,0-32-14.3-32-32s14.3-32,32-32h352C449.7,224,464,238.3,464,256z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "p-card",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313.3,187.4c5.5,9.9,8.3,21.7,8.3,35.3c0,13.4-2.8,25.1-8.3,35.1c-5.5,10-13,17.6-22.3,22.9c-9.3,5.3-19.9,7.9-31.8,7.9 c-11.8,0-22.5-2.6-32-7.9c-9.5-5.3-17-12.9-22.5-22.9c-5.5-10-8.3-21.7-8.3-35.1c0-13.7,2.8-25.5,8.3-35.3 c5.5-9.9,13-17.4,22.5-22.7c9.5-5.3,20.1-7.9,32-7.9c11.9,0,22.4,2.6,31.8,7.9C300.3,169.9,307.8,177.5,313.3,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.6,41.6H127.1c-11,0-20,9-20,20V458c0,11,9,20,20,20h265.5c11,0,20-9,20-20V61.6C412.6,50.5,403.6,41.6,392.6,41.6z  M357.7,279.7c-9.3,16.2-22,28.8-37.9,37.7c-15.9,9-34.3,13.4-55.1,13.4c-17.1,0-32.7-4-46.8-11.8c-7.8-4.4-14.7-10-20.7-16.8 v102.5h-49.4V117.3h47v27.8c6.3-7.7,13.6-13.8,22.1-18.6c14-7.8,29.9-11.6,47.8-11.6c20.8,0,39.1,4.5,55.1,13.4 c15.9,8.9,28.5,21.4,37.9,37.5c9.3,16.1,14,35,14,56.8C371.7,244.5,367.1,263.5,357.7,279.7z"
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "pin",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132,159.5c0-68.5,55.6-124,124-124s124,55.6,124,124s-55.6,124-124,124S132,228,132,159.5z M256,104.4 c7.6,0,13.8-6.2,13.8-13.8s-6.2-13.8-13.8-13.8c-45.7,0-82.7,37-82.7,82.7c0,7.6,6.2,13.8,13.8,13.8s13.8-6.2,13.8-13.8 C200.9,129.1,225.6,104.4,256,104.4z M228.4,448.9V308.6c9,1.6,18.2,2.5,27.6,2.5c9.4,0,18.6-0.9,27.6-2.5v140.3 c0,15.2-12.3,27.6-27.6,27.6C240.8,476.5,228.4,464.2,228.4,448.9z"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,80c0-17.7-14.3-32-32-32s-32,14.3-32,32v144H80c-17.7,0-32,14.3-32,32s14.3,32,32,32h144v144c0,17.7,14.3,32,32,32 s32-14.3,32-32V288h144c17.7,0,32-14.3,32-32s-14.3-32-32-32H288V80z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "racket",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    d: "M462.2,135.6C462.2,135.4,462.2,135.4,462.2,135.6c-6.1-20.9-16.8-39.1-31.8-54 c-14.9-14.9-33.1-25.6-54-31.7l0,0c-13-3.8-26.9-5.8-41.2-5.8c-30.7,0-62.3,8.8-91.3,25.5l0,0c-16.3,9.4-31.5,21-45.1,34.7 s-25.3,28.8-34.7,45.1c-24.7,42.9-31.9,91.2-19.8,132.5l0,0c4.2,14.5,10.7,27.6,19.2,39.3L49.7,435.1c-7.5,7.5-7.5,19.7,0,27.3 c3.8,3.8,8.7,5.6,13.6,5.6c4.9,0,9.9-1.9,13.6-5.6l113.9-113.9c11.7,8.5,24.8,14.9,39.3,19.2l0,0c13,3.8,26.9,5.8,41.2,5.8l0,0 c30.7,0,62.3-8.8,91.3-25.6c16.3-9.4,31.5-21,45.1-34.7c13.6-13.6,25.3-28.8,34.7-45.1C467.1,225.1,474.3,176.8,462.2,135.6z  M420.1,225.6l-16.9-16.9l8.5-8.5l17.6-17.6C428.6,196.7,425.5,211.3,420.1,225.6z M203.4,308.5c-7.8-7.8-13.9-16.9-18.3-27.1 l45.5-45.5l45.4,45.4l-45.5,45.5C220.2,322.5,211.1,316.4,203.4,308.5z M186.5,191.8l16.9,16.9l-26.1,26.1 C177.9,220.7,181.1,206.2,186.5,191.8z M303.3,254.1l-45.4-45.4l45.4-45.4l45.4,45.4L303.3,254.1z M421.5,135.9L376,181.4L330.6,136 l45.5-45.5c10.3,4.4,19.4,10.5,27.1,18.3C411,116.6,417.1,125.7,421.5,135.9z M329.4,82.7l-26.1,26.1l-16.9-16.9 C300.6,86.5,315.1,83.4,329.4,82.7z M226.1,131.4c7.7-7.7,16-14.6,24.7-20.7l11.2,11.2l14,14l-22.7,22.7l-22.7,22.7l-25.2-25.2 C211.4,147.4,218.4,139.2,226.1,131.4z M277.2,334.7l26.1-26.1l16.9,16.9C305.9,330.9,291.4,334,277.2,334.7z M380.5,285.9 c-7.7,7.7-16,14.6-24.7,20.7l-25.2-25.2L376,236l25.2,25.2C395.1,269.9,388.2,278.2,380.5,285.9z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "red-card",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80000",
    d: "M388.7,474.2H123.2c-11,0-20-9-20-20V57.7c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C408.7,465.3,399.8,474.2,388.7,474.2z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.6,233.4c12.5,12.5,12.5,32.8,0,45.3l-192,192c-12.5,12.5-32.8,12.5-45.3,0s-12.5-32.8,0-45.3L307.7,256L138.4,86.6 c-12.5-12.5-12.5-32.8,0-45.3s32.8-12.5,45.3,0l192,192L375.6,233.4z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "square",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5,101.4c0-34.1,27.7-61.9,61.9-61.9h309.3c34.1,0,61.9,27.7,61.9,61.9v309.3c0,34.1-27.7,61.9-61.9,61.9H101.4 c-34.1,0-61.9-27.7-61.9-61.9V101.4z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-check",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.5,86C93,86,86,93,86,101.5v309.3c0,8.5,6.9,15.4,15.4,15.4h309.3c8.5,0,15.4-6.9,15.4-15.4V101.6 c0-8.5-6.9-15.4-15.4-15.4L101.5,86L101.5,86z M39.6,101.6c0-34.1,27.7-61.9,61.9-61.9h309.3c34.1,0,61.9,27.7,61.9,61.9v309.3 c0,34.1-27.7,61.9-61.9,61.9H101.5c-34.1,0-61.9-27.7-61.9-61.9C39.6,410.8,39.6,101.6,39.6,101.6z M365.4,210.7L241.6,334.5 c-9.1,9.1-23.7,9.1-32.7,0L147,272.6c-9.1-9.1-9.1-23.7,0-32.7c9.1-9,23.7-9.1,32.7,0l45.5,45.5l107.3-107.4 c9.1-9.1,23.7-9.1,32.7,0C374.2,187,374.3,201.7,365.4,210.7L365.4,210.7z"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-minus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-plus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "iconStop",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5,111.1c0-39.8,32.4-72.1,72.1-72.1h288.7c39.8,0,72.1,32.4,72.1,72.1v288.7c0,39.8-32.4,72.1-72.1,72.1H111.6 c-39.8,0-72.1-32.4-72.1-72.1V111.1z"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "tennisball",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.6,165.7c-48.8,66.5-136.3,44.9-135.8,42.4C68.3,135.3,133.1,63,207.1,48.7C210.1,48.2,227.3,109.2,185.6,165.7z  M330.6,351.9c48.9-66.5,136.3-44.9,135.8-42.5c-18.5,72.9-83.3,145.2-157.3,159.4C306.1,469.4,289,408.5,330.6,351.9z M256.7,38.9 c119.8,0,215.7,123.9,215.7,243.7c0,0-78.8-27.7-145.2,34.4C251.1,388.1,279.7,472,279.7,472c-7,0.7-16,1.3-23.2,1.3 c-119.9,0-217.2-97.3-217.2-217.2c0-8.7,0.4-17.2,1.5-25.5c0,0,29.5,8.9,49.6,6.6c58.9-7,91.8-32.1,111.4-56.5 c21.5-26.6,28.1-41.8,35.7-79.3c5.5-27.2-4.5-61.2-4.5-61.2C240.6,39.3,248.5,38.9,256.7,38.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: 0.1,
    className: "st0",
    width: 512,
    height: 512
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "themecolor",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbtack",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.4,59.1c0-15.6,12.6-28.1,28.1-28.1h225c15.6,0,28.1,12.6,28.1,28.1s-12.6,28.1-28.1,28.1h-25.9l10,130.3 c32.3,17.5,57.7,46.8,69.9,83.2l0.9,2.6c2.9,8.6,1.4,18-3.9,25.3c-5.3,7.3-13.8,11.7-22.9,11.7H115.4c-9.1,0-17.5-4.3-22.9-11.7 c-5.4-7.4-6.8-16.8-3.9-25.3l0.9-2.6c12.1-36.5,37.6-65.7,69.9-83.2l10-130.3h-25.9C127.9,87.2,115.4,74.7,115.4,59.1z M227.9,368.5 h56.3v84.4c0,15.6-12.6,28.1-28.1,28.1s-28.1-12.6-28.1-28.1V368.5z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "torch1",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1108_",
    d: "M241.4,284.2c-20-6.2-33.5-38.7-21.6-63.2c10.3,21.3,42.5,24.4,61.4,10.9c27.1-19.2,22.5-56.5,20-60 c0,0,16.2,17.1,22.8,41.9c6.5,24.8,3,57.3-24.4,69.8c31.9,2.2,90.1-49.2,64.4-113.3c-15.7-39.5-71.9-77.9-39.2-93.1 c-11.3-4.1-51.9,1-52.2,40.6C253.3,97.4,246,44.4,256.9,14.3C195.5,32.5,113,160.9,175.7,239.1c-14.9-3-28.7-14.3-33.8-27.8 C138.9,233.9,174.9,284.2,241.4,284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1087_",
    d: "M305.5,328.3h-98.9c-6.5,0-11.9-5.4-11.9-11.9v-20h122.5v20C317.4,323.2,312,328.3,305.5,328.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1081_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1082_",
    d: "M273.9,497.7c0.6-61.4,10.6-130.6,21.6-170.1h-79.2c11,39.5,21.1,108.7,21.6,170.1H273.9z"
  }))))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "torch2",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020203;",
    d: "M128.3,357.1c-2.4,0-4.7-0.8-7.1-2.4c-42.1-30.9-56.4-65.9-45.3-111.2c4.7-18.6,14.7-35.3,24.3-51.6 c10.7-17.8,21-35,22.2-52.8c0.4-5.2,4-9.5,9.1-10.7c5.2-1.2,10.3,0.8,13.1,5.2c8.3,12.7,12.3,23.5,14.7,34.5 c42.1-48.1,60.4-88.9,54.4-122.7c-0.8-4,0.8-8.3,3.6-11.2c3.2-2.8,7.1-4,11.2-2.8c3.2,0.8,72.2,19.9,109.6,105.2 c0.8-9.1-1.6-19.1-5.2-25.8c-2.8-4.7-1.6-10.7,2.4-14.7c4-3.6,9.9-4.4,14.7-1.6c21.9,13.5,86.6,75.1,89.7,145.4 c2,43.7-19.1,81.8-62.8,114.3c-5.2,4-12.7,2.8-17.1-2.4c-4-5.2-2.8-12.7,2.4-17.1c36.6-27.4,54.4-58.8,52.8-94.1 c-2-40.9-30.1-80.2-53.2-104.1c-1.2,14.7-7.1,28.6-19.1,37.7c-3.2,2.4-7.1,3.2-11.2,2c-3.6-1.2-6.8-4-7.9-7.9 c-20.7-65.9-62.3-95.3-85.8-107.2c-1.6,41.3-28.2,88.9-79.8,141.8c-3.2,3.6-8.3,4.4-12.7,2.8c-4.4-1.6-7.6-5.5-7.9-10.3 c-0.4-7.6-1.2-13.9-2-19.4c-4.4,9.5-9.9,19.1-15.5,28.2c-9.1,15.1-17.5,29.8-21.4,44.9c-8.7,35.8,1.6,60.4,36.1,85.8 c5.5,4,6.3,11.5,2.8,16.7C135.9,355.5,132.3,357.1,128.3,357.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203;",
    d: "M320.9,481h-12.7c-5.5,0-9.9-5.5-9.9-12c0-6.8,4.4-12,9.9-12h12.7c22.2,0,40.1-21.9,40.1-48.4 c0-12.7-4.4-25-12-34.2c-7.6-9.1-17.5-14.3-28.2-14.3H177.2c-22.2,0-40.1,21.9-40.1,48.4c0,12.7,4,25,12,34.2 c7.6,9.1,17.5,14.3,28.2,14.3H190c5.5,0,9.9,5.5,9.9,12c0,6.8-4.4,12-9.9,12h-12.7c-15.9,0-30.9-7.6-42.5-21 c-11.5-13.4-17.7-31.8-17.7-51.2c0-40.1,27-72.2,59.9-72.2h143.8c15.9,0,30.9,7.6,42.5,21c11.5,13.5,17.5,31.7,17.5,51.2 C380.9,448.4,353.8,481,320.9,481z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020203;",
    d: "M363.4,360.2H135.9c-8.3,0-14.7-5.5-14.7-12c0-6.8,6.8-12,14.7-12h227.5c8.3,0,14.7,5.5,14.7,12 C378.1,354.7,371.3,360.2,363.4,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203;",
    d: "M320.5,481H188.2c-8.3,0-14.7-5.5-14.7-12c0-6.3,6.8-12,14.7-12h132.3c8.3,0,14.7,5.5,14.7,12 S328.9,481,320.5,481z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "tout",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 57.8,
    className: "st0",
    style: {
      fill: "#FFFFFF"
    },
    width: 265.5,
    height: 396.4
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.9,494.3H122.5c-22.1,0-40-17.9-40-40V57.7c0-22.1,17.9-40,40-40H388c22.1,0,40,17.9,40,40v396.5 C427.9,476.3,410,494.3,387.9,494.3z M122.5,454.2C122.5,454.2,122.5,454.3,122.5,454.2H388V57.7c0,0,0,0-0.1,0H122.5c0,0,0,0,0,0.1 V454.2L122.5,454.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.7,204h97.7v25.7h-32.8V308h-32.1v-78.3h-32.8V204z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,256.1c0-17,4.7-30.2,14.2-39.7s22.6-14.2,39.5-14.2c17.3,0,30.6,4.6,40,13.9c9.4,9.3,14,22.3,14,39.1 c0,12.2-2,22.1-6.1,29.9s-10,13.8-17.7,18.2c-7.7,4.3-17.4,6.5-28.9,6.5c-11.7,0-21.4-1.9-29.1-5.6s-13.9-9.6-18.7-17.7 C255.4,278.4,253,268.2,253,256.1z M285.1,256.2c0,10.5,2,18,5.9,22.6s9.2,6.9,15.9,6.9c6.9,0,12.2-2.2,16-6.7s5.7-12.6,5.7-24.2 c0-9.8-2-16.9-5.9-21.5c-3.9-4.5-9.3-6.8-16.1-6.8c-6.5,0-11.7,2.3-15.6,6.9C287.1,238,285.1,245.6,285.1,256.2z"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,66.5c12,0,23.1,6.3,29.2,16.7l182.7,311.2C474,405,474,418,468,428.5c-6,10.5-17.3,17-29.3,17H73.3 c-12.1,0-23.3-6.5-29.3-17s-5.9-23.5,0.2-33.9L226.8,83.3C232.9,72.9,244,66.5,256,66.5z"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangle-up",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,66.7c5.6,0,10.7,2.9,13.5,7.8l84.6,144.1c2.9,4.9,2.9,10.8,0.1,15.7s-8,7.9-13.6,7.9H171.4c-5.6,0-10.8-3-13.6-7.9 c-2.8-4.9-2.7-10.9,0.1-15.7l84.6-144.1C245.3,69.6,250.4,66.7,256,66.7z"
  })))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "trianlge-down",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,445.3c-5.6,0-10.7-2.9-13.5-7.8l-84.6-144.1c-2.9-4.9-2.9-10.8-0.1-15.7s8-7.9,13.6-7.9h169.2c5.6,0,10.8,3,13.6,7.9 c2.8,4.9,2.7,10.9-0.1,15.7l-84.6,144.1C266.7,442.4,261.6,445.3,256,445.3z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "TTE-racket",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.5,226.1l166.4,166.3c-20.5-0.3-40.9-3.9-60.2-11.6c-7.7-1.5-38.9-6.5-50.8,5.4 c-27.2,27.2-52,64.3-65.6,77.9c-13.6,13.6-32.9,7.9-51.1-10.3c-18.3-18.3-23.5-37.9-10.3-51.1s50.7-38.4,77.9-65.6 c12.5-12.5,6-47,5-51.8C123.3,266.2,119.9,246.2,119.5,226.1z M422.1,89.8c-80.9-80.9-187.2-52.6-253.4,13.6 c-24.5,24.5-39.9,54.6-46.3,86.2l199.8,199.8c31.6-6.4,61.7-21.7,86.2-46.2C474.7,277,503,170.7,422.1,89.8z"
  })))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "turn-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436,118.8c0-16.7,13.5-30.2,30.2-30.2c16.7,0,30.2,13.5,30.2,30.2v90.6c0,50-40.6,90.6-90.6,90.6H116.2l69.3,69.3 c11.8,11.8,11.8,31,0,42.8c-11.8,11.8-31,11.8-42.8,0L21.9,291.3c-11.8-11.8-11.8-31,0-42.8l120.9-120.9c11.8-11.8,31-11.8,42.8,0 c11.8,11.8,11.8,31,0,42.8l-69.3,69.2h289.6c16.7,0,30.2-13.5,30.2-30.2V118.8z"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "up",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.4,105.4c12.5-12.5,32.8-12.5,45.3,0l192,192c12.5,12.5,12.5,32.8,0,45.3s-32.8,12.5-45.3,0L256,173.3L86.6,342.6 c-12.5,12.5-32.8,12.5-45.3,0s-12.5-32.8,0-45.3L233.4,105.4L233.4,105.4z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "video",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,156c0-27.6,22.4-50,50-50h200c27.6,0,50,22.4,50,50v200c0,27.6-22.4,50-50,50H81c-27.6-0.1-50-22.5-50-50.1V156z  M467.8,133.9c8.2,4.3,13.2,12.8,13.2,22v200c0,9.2-5.1,17.6-13.2,22c-8.2,4.3-18,3.9-25.7-1.2l-75-49.9l-11.1-7.4v-13.4v-100v-13.4 l11.1-7.4l75-50C449.8,130.1,459.6,129.6,467.8,133.9L467.8,133.9z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "videoreview",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M467.5,130.9c8.3,4.5,13.5,13.1,13.5,22.6v205c0,9.5-5.2,18.1-13.5,22.6c-8.3,4.5-18.5,4-26.4-1.3l-76.9-51.2l-11.3-7.6 v-13.7V204.8V191l11.3-7.6l76.9-51.2C449,127,459,126.4,467.5,130.9L467.5,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd;clip-rule:evenodd;",
    d: "M287.2,102.3h-205c-28.3,0-51.2,22.9-51.2,51.2v205c0,28.3,23,51.2,51.2,51.2h205c28.3,0,51.2-22.9,51.2-51.2 v-205C338.4,125.2,315.5,102.3,287.2,102.3z M268.7,319.8l-15.8,15.8c-18.1,18.2-42.6,28.3-68.2,28.3c-25.5,0-49.9-10.1-68-28 l-19,19c-1.7,1.7-4,2.6-6.4,2.6c-4.9,0-9.1-4-9.1-9.1V287c0-7,5.8-12.8,12.8-12.8h61.4c4.9,0,9.1,4,9.1,9.1c0,2.4-1,4.7-2.6,6.4 l-19,19c10.8,10.7,25.5,16.9,40.8,16.9c15.4,0,30.1-6.1,41-17.1l15.7-15.8c7.6-7.6,19.7-7.6,27.2,0 C276.2,300.2,276.2,312.3,268.7,319.8z M287.2,235.8c0,7-5.8,12.8-12.8,12.8h-61.4c-5,0-9.1-4-9.1-9.1c0-2.4,1-4.7,2.6-6.4l19-19 c-10.9-10.7-25.6-16.8-40.9-16.8c-15.4,0-30.1,6.1-41,17.1l-15.8,15.7c-7.6,7.6-19.7,7.6-27.2,0c-7.5-7.6-7.6-19.7,0-27.2 l15.8-15.7c18.1-18.2,42.6-28.3,68.2-28.3c25.5,0,50,10.1,68,28l19-19c1.7-1.7,4-2.6,6.4-2.6c4.9,0,9.1,4,9.1,9.1L287.2,235.8 L287.2,235.8z"
  })))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "volleyball",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.3,265.6c-22.1,7.4-45.2,11.7-68.5,12.8c7.8-89.1-26.6-172.7-87.3-230.4c90.1,26.2,155.9,109.4,155.9,208 C472.5,259.2,472.4,262.4,472.3,265.6z M469,295c-4.9,27.1-14.9,52.4-28.9,75c-82.5,41-184.1,36-263.8-20.7 c20-30.6,46.9-57.3,79.9-77.6C323.8,308.2,400.1,314.6,469,295z M269.4,248.1c-2.1-76.9-34.8-146.1-86.2-195.9 c22.7-8.2,47.2-12.6,72.7-12.6c2.3,0,4.5,0,6.7,0.1C339.5,90.5,385.9,181,376.6,278.3C340.1,276.3,303.5,266.4,269.4,248.1 L269.4,248.1z M156.2,63.9c17.4,15.5,32.7,33.3,45.4,52.9c-81,37.8-136.2,109.4-155.9,190.7c-4.1-16.5-6.2-33.7-6.2-51.5 C39.5,172.4,86.9,100,156.2,63.9z M215.1,140.4c16.5,32.6,26.2,69.3,27.3,108c-65.5,40.3-109.1,103.1-126.6,172.5 c-20.5-17.4-37.7-38.6-50.6-62.4C70.9,266.6,126,181,215.1,140.4L215.1,140.4z M256,472.5c-42.9,0-82.9-12.4-116.5-34 c4.7-22.8,12.5-44.9,23.2-65.7c73.2,51.2,162.8,63.2,243.1,39.7C366.8,449.7,314.1,472.5,256,472.5z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "yellow-card",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE000",
      stroke: "#000000",
      strokeWidth: 10,
      strokeMiterlimit: 10
    },
    d: "M388.7,474.2H123.2c-11,0-20-9-20-20V57.7c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C408.7,465.3,399.8,474.2,388.7,474.2z"
  })), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "yr1",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE000",
    d: "M350.7,449.2H85.2c-11,0-20-9-20-20V32.7c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C370.7,440.3,361.8,449.2,350.7,449.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80000",
    d: "M409.2,499.8H143.7c-11,0-20-9-20-20V83.2c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C429.2,490.8,420.3,499.8,409.2,499.8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.1,216.8v127.5h-35.2v-83.6c-5.7,4.3-11.2,7.8-16.6,10.5c-5.3,2.7-12,5.2-20.1,7.7v-28.6c11.9-3.8,21.1-8.4,27.6-13.8 c6.6-5.4,11.7-12,15.4-19.8H304.1z"
  })))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "yr2",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE000",
    d: "M350.7,449.2H85.2c-11,0-20-9-20-20V32.7c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C370.7,440.3,361.8,449.2,350.7,449.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80000",
    d: "M409.2,499.8H143.7c-11,0-20-9-20-20V83.2c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C429.2,490.8,420.3,499.8,409.2,499.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M327.2,344.3H222.6c1.2-10.3,4.8-20,10.9-29.1c6.1-9.1,17.5-19.8,34.2-32.2c10.2-7.6,16.7-13.3,19.6-17.3 c2.8-3.9,4.3-7.7,4.3-11.2c0-3.8-1.4-7.1-4.2-9.8c-2.8-2.7-6.4-4.1-10.6-4.1c-4.4,0-8.1,1.4-10.9,4.2c-2.8,2.8-4.7,7.7-5.7,14.8 l-34.9-2.8c1.4-9.8,3.9-17.5,7.5-23c3.6-5.5,8.8-9.7,15.4-12.7c6.6-2.9,15.8-4.4,27.6-4.4c12.3,0,21.8,1.4,28.6,4.2 c6.8,2.8,12.2,7.1,16.1,12.9c3.9,5.8,5.9,12.3,5.9,19.5c0,7.6-2.2,14.9-6.7,21.9c-4.5,7-12.6,14.6-24.4,22.9 c-7,4.8-11.7,8.2-14.1,10.2c-2.4,1.9-5.1,4.5-8.3,7.6h54.4V344.3z"
  })))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_substitution_concussion",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M45.8,80.9c-1.4-0.2-2.7-0.6-4.1-1c-5.4-1.7-10.1-4.8-13.9-9c-0.5-0.5-1-1-1.7-1.3c-0.6-0.3-1.3-0.5-2-0.6 c-0.7-0.1-1.4,0-2.1,0.3c-0.7,0.2-1.3,0.6-1.8,1.1c-0.5,0.5-1,1-1.3,1.7c-0.3,0.6-0.5,1.3-0.5,2.1c0,0.7,0.1,1.4,0.3,2.1 c0.2,0.7,0.6,1.3,1.1,1.8c5,5.7,11.4,9.9,18.6,12.1c4.2,1.3,8.5,2,12.9,2C48.9,88.7,47,85,45.8,80.9z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,20c5.5-1.3,11.2-1.1,16.5,0.6c5.4,1.7,10.1,4.8,13.9,9c0.9,1.1,2.3,1.7,3.7,1.8c1.4,0.1,2.8-0.4,3.9-1.3 c1.1-0.9,1.7-2.3,1.8-3.7c0.1-1.4-0.4-2.8-1.3-3.9c-5-5.7-11.4-9.9-18.6-12.1c-7.2-2.3-14.9-2.6-22.2-0.8c-7.5,1.9-14.3,5.7-19.8,11 c-5.5,5.3-9.6,12-11.7,19.4c-0.1,0.2-0.2,0.5-0.4,0.6c-0.2,0.1-0.5,0.2-0.7,0.2l-4.4-0.6c-0.4-0.1-0.8,0-1.1,0.2 c-0.4,0.2-0.7,0.4-0.9,0.8c-0.2,0.3-0.3,0.7-0.4,1.1c0,0.4,0.1,0.8,0.3,1.1L12.2,62c0.2,0.3,0.4,0.5,0.7,0.7 c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0c0.3,0,0.6-0.1,0.8-0.2c0.3-0.1,0.5-0.3,0.7-0.5l14.9-15.4c0.3-0.3,0.5-0.6,0.6-1 c0.1-0.4,0.1-0.8-0.1-1.2c-0.1-0.4-0.4-0.7-0.7-1c-0.3-0.2-0.7-0.4-1.1-0.5l-8-1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.2,0-0.3,0.1-0.5c1.8-5.1,4.8-9.7,8.9-13.4C33.2,24,38.1,21.4,43.3,20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5,60.8h11.1c1.2,0,2.4,0.5,3.3,1.4c0.9,0.9,1.4,2.1,1.4,3.3v8.2c0,1.2-0.5,2.4-1.4,3.3c-0.9,0.9-2.1,1.4-3.3,1.4H85.5 c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4V90c0,1.2-0.5,2.4-1.4,3.3c-0.9,0.9-2.1,1.4-3.3,1.4h-8.2c-1.2,0-2.4-0.5-3.3-1.4 c-0.9-0.9-1.4-2.1-1.4-3.3V78.9c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2H55.8c-1.2,0-2.4-0.5-3.3-1.4 c-0.9-0.9-1.4-2.1-1.4-3.3v-8.2c0-1.2,0.5-2.4,1.4-3.3c0.9-0.9,2.1-1.4,3.3-1.4h11.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1 c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2V49.1c0-1.2,0.5-2.4,1.4-3.3c0.9-0.9,2.1-1.4,3.3-1.4h8.2c1.2,0,2.4,0.5,3.3,1.4 c0.9,0.9,1.4,2.1,1.4,3.3v11.1c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1C85.4,60.7,85.5,60.8,85.5,60.8z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 105 105",
    id: "FBL_assist"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M33,88c2.1,0.9,3,3.4,2.1,5.5c-0.9,2.1-3.4,3-5.5,2.1C8.1,86-3.8,62.7,1.1,39.6C6,16.6,26.3,0.1,49.9,0 c23.6-0.1,44,16.3,49,39.3c5,23-6.7,46.4-28.2,56.2c-1.4,0.6-3,0.5-4.2-0.4c-1.2-0.9-1.9-2.3-1.7-3.8c0.1-1.5,1.1-2.8,2.5-3.4 c17.9-8.1,27.7-27.6,23.5-46.8C86.5,21.9,69.5,8.3,49.9,8.3c-19.6,0-36.6,13.8-40.7,33C5.2,60.5,15.1,80,33,88z M56.2,58.3v35.4 c0,3.5-2.8,6.2-6.2,6.2c-3.5,0-6.2-2.8-6.2-6.2V58.3H28.3c-1.6,0-3.1-0.9-3.8-2.4c-0.7-1.4-0.5-3.1,0.5-4.4l21.7-27.1 c0.8-1,2-1.6,3.3-1.6c1.3,0,2.5,0.6,3.3,1.6l21.7,27.1c1,1.3,1.2,3,0.5,4.4c-0.7,1.4-2.2,2.4-3.8,2.4H56.2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_expulsion",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M49,0.5C44.3-0.3,39.7,2,37.5,6.1l-25.7,0l-1.1,0.1c-5.6,0.5-10,5.2-10,11v73.5l0.1,1.1c0.5,5.6,5.2,10,11,10 h45.6l10.5,2.8l1,0.2c5.5,0.9,11-2.5,12.5-8l19-71l0.2-1c0.9-5.5-2.5-11-8-12.5L50,0.7L49,0.5z M35.2,13.4L17.5,79.5l-0.2,1 c-0.9,5.5,2.5,11,8,12.5l4.6,1.2l-18.1,0l-0.7-0.1c-1.7-0.3-3-1.8-3-3.6V17.1l0.1-0.7c0.3-1.7,1.8-3,3.6-3L35.2,13.4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_goal_scored",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M22.2,8.9C30.4,3.4,40.1,0.5,50,0.5c13.3,0,26,5.3,35.3,14.7c9.4,9.4,14.6,22.1,14.7,35.3 c0,9.9-2.9,19.6-8.4,27.8S78.3,92.9,69.1,96.7c-9.1,3.8-19.2,4.8-28.9,2.8c-9.7-1.9-18.6-6.7-25.6-13.7C7.7,78.9,2.9,70,1,60.3 C-1,50.6,0,40.5,3.8,31.4C7.6,22.2,14,14.4,22.2,8.9z M54.6,16.7c-0.2,0.3-0.3,0.7-0.3,1.1l0,10.8c0,0.3,0.1,0.7,0.2,0.9 c0.1,0.3,0.4,0.5,0.6,0.7l14.6,10.6c0.3,0.2,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.2l8.1-4.3c0.3-0.2,0.6-0.4,0.8-0.7 c0.2-0.3,0.3-0.6,0.3-1L82.2,22c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.3-0.5-0.5-0.7c-3.7-3.9-8-7-12.8-9.3c-0.3-0.1-0.6-0.2-0.9-0.2 c-0.3,0-0.6,0.1-0.9,0.2l-11.6,4.9C55.1,16.1,54.8,16.4,54.6,16.7z M18.5,20.2c3.7-3.8,8-7,12.8-9.2c0.3-0.1,0.6-0.2,0.9-0.2 c0.3,0,0.6,0.1,0.9,0.2l11.6,5c0.4,0.2,0.7,0.4,0.9,0.8c0.2,0.3,0.3,0.7,0.3,1.1v10.8c0,0.3-0.1,0.6-0.2,0.9 c-0.1,0.3-0.4,0.5-0.6,0.7L30.8,40.6c-0.3,0.2-0.7,0.4-1,0.4c-0.4,0-0.8,0-1.1-0.2l-8.5-4.1c-0.3-0.2-0.6-0.4-0.8-0.7 s-0.3-0.6-0.4-1l-1.2-13.1c0-0.3,0-0.6,0.1-0.9C18.1,20.7,18.3,20.5,18.5,20.2z M27.7,74.5l4.7-5.2c0.2-0.3,0.4-0.6,0.5-1 c0.1-0.4,0.1-0.7-0.1-1.1l-5.3-16.4c-0.2-0.5-0.5-0.9-1-1.2L17.7,45c-0.4-0.2-0.9-0.3-1.4-0.2c-0.5,0.1-0.9,0.3-1.2,0.7l-8,9.2 c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.3-0.1,0.6-0.1,0.9c0.7,5.2,2.3,10.3,4.8,14.9c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.2,0.5,0.3,0.8,0.4 l12.8,2.9c0.4,0.1,0.7,0.1,1.1,0C27.1,75,27.4,74.8,27.7,74.5z M65.7,81.8l-6.4,10.7c-0.2,0.3-0.4,0.5-0.6,0.6 c-0.2,0.2-0.5,0.3-0.8,0.3c-5.2,0.9-10.4,0.9-15.6,0c-0.3-0.1-0.6-0.2-0.8-0.3c-0.2-0.2-0.5-0.4-0.6-0.6l-6.4-10.7 c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.4,0.2-0.9,0.5-1.2l4.7-5.2c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.2h18.3 c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5l4.7,5.2c0.3,0.3,0.5,0.7,0.5,1.2C66,81,65.9,81.4,65.7,81.8L65.7,81.8z M87.9,71.9 c0.2-0.2,0.4-0.4,0.6-0.7l0,0c2.5-4.6,4.2-9.7,4.8-14.9c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.8l-8-9.3 c-0.3-0.4-0.7-0.6-1.2-0.7c-0.5-0.1-0.9,0-1.4,0.2l-8.8,4.7c-0.5,0.3-0.8,0.7-1,1.2l-5.3,16.4c-0.1,0.3-0.1,0.7-0.1,1.1 c0.1,0.4,0.2,0.7,0.5,1l4.7,5.2c0.2,0.3,0.6,0.5,0.9,0.6c0.4,0.1,0.7,0.1,1.1,0l12.8-2.9C87.4,72.2,87.7,72,87.9,71.9z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_own_goal",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    className: "st0",
    d: "M1.9,52.9c0-27.6,22.4-50,50-50s50,22.4,50,50s-22.4,50-50,50S1.9,80.6,1.9,52.9z M93.8,52.9 c0-23.1-18.7-41.8-41.8-41.8S10.1,29.8,10.1,52.9s18.7,41.8,41.8,41.8S93.8,76,93.8,52.9z M67.4,31.7c1.6-1.6,4.2-1.6,5.8,0 c1.4,1.4,1.6,3.6,0.5,5.2l-0.5,0.6L57.7,52.9l15.5,15.5c1.6,1.6,1.6,4.2,0,5.8c-1.4,1.4-3.6,1.6-5.2,0.5l-0.6-0.5L51.9,58.7 L36.5,74.2c-1.6,1.6-4.2,1.6-5.8,0c-1.4-1.4-1.6-3.6-0.5-5.2l0.5-0.6l15.5-15.5L30.7,37.5c-1.6-1.6-1.6-4.2,0-5.8 c1.4-1.4,3.6-1.6,5.2-0.5l0.6,0.5l15.5,15.5L67.4,31.7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M100,15C99.5,6.7,93.1,0,85.2,0H14.8l-1,0C6.1,0.6,0,7.6,0,16.1v77.7h6.2V16.1l0-1c0.4-5,4.2-8.9,8.6-8.9h70.3 l0.8,0c4.3,0.5,7.8,4.6,7.8,9.8v77.7h6.2V16.1L100,15z M50,11.7c-21.1,0-38.3,17.1-38.3,38.3S28.9,88.3,50,88.3S88.3,71.1,88.3,50 S71.1,11.7,50,11.7z M50,18c17.7,0,32,14.3,32,32S67.7,82,50,82S18,67.7,18,50S32.3,18,50,18z M61.8,33.7c1.2-1.2,3.2-1.2,4.4,0 c1.1,1.1,1.2,2.8,0.4,4l-0.4,0.4L54.4,50l11.9,11.9c1.2,1.2,1.2,3.2,0,4.4c-1.1,1.1-2.8,1.2-4,0.4l-0.4-0.4L50,54.4L38.1,66.3 c-1.2,1.2-3.2,1.2-4.4,0c-1.1-1.1-1.2-2.8-0.4-4l0.4-0.4L45.6,50L33.7,38.1c-1.2-1.2-1.2-3.2,0-4.4c1.1-1.1,2.8-1.2,4-0.4l0.4,0.4 L50,45.6L61.8,33.7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_penalty_scored",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M100,15C99.5,6.7,93.1,0,85.2,0H14.8l-1,0C6.1,0.6,0,7.6,0,16.1v77.7h6.2V16.1l0-1c0.4-5,4.2-8.9,8.6-8.9h70.3 l0.8,0c4.3,0.5,7.8,4.6,7.8,9.8v77.7h6.2V16.1L100,15z M50,12.5c-7.4,0-14.7,2.2-20.8,6.3s-11,10-13.8,16.8 c-2.8,6.9-3.6,14.4-2.1,21.7c1.4,7.3,5,14,10.3,19.2c5.2,5.2,11.9,8.8,19.2,10.3c7.3,1.4,14.8,0.7,21.7-2.1 c6.9-2.8,12.7-7.6,16.8-13.8s6.3-13.4,6.3-20.8c0-9.9-4-19.5-11-26.5C69.5,16.5,59.9,12.5,50,12.5z M53.2,25.5 c0-0.3,0.1-0.6,0.3-0.9c0.2-0.3,0.4-0.5,0.7-0.6l8.7-3.7c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0.1,0.6,0.2c3.6,1.7,6.9,4.1,9.6,7 c0.2,0.2,0.3,0.4,0.3,0.6c0.1,0.2,0.1,0.4,0.1,0.7l-0.9,9.9c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.3,0.4-0.6,0.5l-6,3.2 c-0.3,0.1-0.6,0.2-0.8,0.2c-0.3,0-0.6-0.1-0.8-0.3l-10.9-8c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.2-0.2-0.5-0.2-0.7L53.2,25.5z M36,20.4 c-3.6,1.7-6.8,4.1-9.6,6.9c-0.2,0.2-0.3,0.4-0.3,0.6c-0.1,0.2-0.1,0.4-0.1,0.7l0.9,9.9c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.4,0.4,0.6,0.5l6.3,3.1c0.3,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.3l10.6-7.7c0.2-0.1,0.4-0.3,0.5-0.5 c0.1-0.2,0.2-0.5,0.2-0.7v-8.1c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.4-0.5-0.7-0.6l-8.7-3.7c-0.2-0.1-0.4-0.1-0.6-0.1 C36.4,20.2,36.2,20.3,36,20.4z M36.8,64.1L33.3,68c-0.2,0.2-0.4,0.4-0.7,0.4c-0.3,0.1-0.6,0.1-0.8,0l-9.6-2.2 c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.5c-1.9-3.5-3.1-7.3-3.6-11.2c0-0.2,0-0.4,0-0.6c0.1-0.2,0.2-0.4,0.3-0.6l6-6.9 c0.2-0.3,0.5-0.4,0.9-0.5c0.3-0.1,0.7,0,1,0.2l6.6,3.5c0.4,0.2,0.6,0.5,0.8,0.9l4,12.3c0.1,0.3,0.1,0.5,0,0.8 C37.1,63.7,37,63.9,36.8,64.1z M57,81.5l4.8-8.1l0,0c0.2-0.3,0.2-0.6,0.2-1c0-0.3-0.2-0.6-0.4-0.9l-3.5-3.9 c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1H43.2c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.4l-3.5,3.9 c-0.2,0.2-0.4,0.6-0.4,0.9c0,0.3,0,0.7,0.2,1l4.8,8.1c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.1,0.4,0.2,0.6,0.3c3.9,0.7,7.8,0.7,11.7,0 c0.2,0,0.4-0.1,0.6-0.3C56.7,81.9,56.9,81.7,57,81.5z M78.9,65.5c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.1-0.4,0.2-0.6,0.3l-9.6,2.2 c-0.3,0.1-0.6,0.1-0.8,0c-0.3-0.1-0.5-0.2-0.7-0.4l-3.5-3.9c-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3,0-0.5,0-0.8l4-12.3 c0.1-0.4,0.4-0.7,0.8-0.9l6.6-3.5c0.3-0.2,0.7-0.2,1-0.2c0.3,0.1,0.7,0.2,0.9,0.5l6,7c0.1,0.2,0.3,0.4,0.3,0.6 c0.1,0.2,0.1,0.4,0.1,0.7C82,58.3,80.8,62.1,78.9,65.5L78.9,65.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_second_penalty_missed",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M21.8,8.9c2.6-1.1,5.4-1.7,8.4-1.7h10.9c1.7,0,3.1-1.4,3.1-3.1S42.8,1,41.1,1H30.1c-3.8,0-7.4,0.8-10.8,2.1 c-1.6,0.7-2.4,2.5-1.7,4.1C18.3,8.8,20.2,9.6,21.8,8.9z M62.9,1c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h10.9c3,0,5.8,0.6,8.4,1.7 c1.6,0.7,3.4-0.1,4.1-1.7c0.7-1.6-0.1-3.4-1.7-4.1C81.3,1.8,77.7,1,73.9,1H62.9z M9.9,20.8c0.7-1.6-0.1-3.4-1.7-4.1 c-1.6-0.7-3.4,0.1-4.1,1.7C2.8,21.7,2,25.3,2,29.1v10.9c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1V29.1 C8.3,26.2,8.8,23.3,9.9,20.8z M99.9,18.4c-0.7-1.6-2.5-2.4-4.1-1.7c-1.6,0.7-2.4,2.5-1.7,4.1c1.1,2.6,1.7,5.4,1.7,8.4v10.9 c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1V29.1C102,25.3,101.2,21.7,99.9,18.4z M8.3,61.9c0-1.7-1.4-3.1-3.1-3.1 c-1.7,0-3.1,1.4-3.1,3.1v10.9c0,3.8,0.8,7.4,2.1,10.8c0.7,1.6,2.5,2.4,4.1,1.7c1.6-0.7,2.4-2.5,1.7-4.1c-1.1-2.6-1.7-5.4-1.7-8.4 V61.9z M102,61.9c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1v10.9c0,3-0.6,5.8-1.7,8.4c-0.7,1.6,0.1,3.4,1.7,4.1 c1.6,0.7,3.4-0.1,4.1-1.7c1.4-3.3,2.1-7,2.1-10.8V61.9z M21.8,93.1c-1.6-0.7-3.4,0.1-4.1,1.7c-0.7,1.6,0.1,3.4,1.7,4.1 c3.3,1.4,7,2.1,10.8,2.1h10.9c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1H30.1C27.2,94.8,24.3,94.2,21.8,93.1z M84.6,98.9 c1.6-0.7,2.4-2.5,1.7-4.1c-0.7-1.6-2.5-2.4-4.1-1.7c-2.6,1.1-5.4,1.7-8.4,1.7H62.9c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h10.9 C77.7,101,81.3,100.2,84.6,98.9z M52,12.7c-21.1,0-38.3,17.1-38.3,38.3c0,21.1,17.1,38.3,38.3,38.3c21.1,0,38.3-17.1,38.3-38.3 C90.3,29.9,73.1,12.7,52,12.7z M52,19c17.7,0,32,14.3,32,32c0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C20,33.3,34.3,19,52,19z  M63.8,34.7c1.2-1.2,3.2-1.2,4.4,0c1.1,1.1,1.2,2.8,0.4,4l-0.4,0.4L56.4,51l11.9,11.9c1.2,1.2,1.2,3.2,0,4.4c-1.1,1.1-2.8,1.2-4,0.4 l-0.4-0.4L52,55.4L40.1,67.3c-1.2,1.2-3.2,1.2-4.4,0c-1.1-1.1-1.2-2.8-0.4-4l0.4-0.4L47.6,51L35.7,39.1c-1.2-1.2-1.2-3.2,0-4.4 c1.1-1.1,2.8-1.2,4-0.4l0.4,0.4L52,46.6L63.8,34.7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 105 105",
    id: "FBL_second_penalty_scored"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    className: "st0",
    d: "M22.8,10.9c2.6-1.1,5.4-1.7,8.4-1.7h10.9c1.7,0,3.1-1.4,3.1-3.1S43.8,3,42.1,3H31.1c-3.8,0-7.4,0.8-10.8,2.1 c-1.6,0.7-2.4,2.5-1.7,4.1C19.3,10.8,21.2,11.6,22.8,10.9z M63.9,3c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h10.9 c3,0,5.8,0.6,8.4,1.7c1.6,0.7,3.4-0.1,4.1-1.7c0.7-1.6-0.1-3.4-1.7-4.1C82.3,3.8,78.7,3,74.9,3H63.9z M10.9,22.8 c0.7-1.6-0.1-3.4-1.7-4.1c-1.6-0.7-3.4,0.1-4.1,1.7C3.8,23.7,3,27.3,3,31.1v10.9c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1V31.1 C9.2,28.2,9.8,25.3,10.9,22.8z M100.9,20.4c-0.7-1.6-2.5-2.4-4.1-1.7c-1.6,0.7-2.4,2.5-1.7,4.1c1.1,2.6,1.7,5.4,1.7,8.4v10.9 c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1V31.1C103,27.3,102.2,23.7,100.9,20.4z M9.2,63.9c0-1.7-1.4-3.1-3.1-3.1S3,62.2,3,63.9v10.9 c0,3.8,0.8,7.4,2.1,10.8c0.7,1.6,2.5,2.4,4.1,1.7c1.6-0.7,2.4-2.5,1.7-4.1c-1.1-2.6-1.7-5.4-1.7-8.4V63.9z M103,63.9 c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1v10.9c0,3-0.6,5.8-1.7,8.4c-0.7,1.6,0.1,3.4,1.7,4.1c1.6,0.7,3.4-0.1,4.1-1.7 c1.4-3.3,2.1-7,2.1-10.8V63.9z M22.8,95.1c-1.6-0.7-3.4,0.1-4.1,1.7c-0.7,1.6,0.1,3.4,1.7,4.1c3.3,1.4,7,2.1,10.8,2.1h10.9 c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1H31.1C28.2,96.8,25.3,96.2,22.8,95.1z M85.6,100.9c1.6-0.7,2.4-2.5,1.7-4.1 c-0.7-1.6-2.5-2.4-4.1-1.7c-2.6,1.1-5.4,1.7-8.4,1.7H63.9c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h10.9 C78.7,103,82.3,102.2,85.6,100.9z M53,15.5c-7.4,0-14.7,2.2-20.8,6.3c-6.2,4.1-11,10-13.8,16.8c-2.8,6.9-3.6,14.4-2.1,21.7 c1.4,7.3,5,14,10.3,19.2c5.2,5.2,11.9,8.8,19.2,10.3c7.3,1.4,14.8,0.7,21.7-2.1c6.9-2.8,12.7-7.6,16.8-13.8s6.3-13.4,6.3-20.8 c0-9.9-4-19.5-11-26.5C72.5,19.5,62.9,15.5,53,15.5z M56.2,28.5c0-0.3,0.1-0.6,0.3-0.9c0.2-0.3,0.4-0.5,0.7-0.6l8.7-3.7 c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0.1,0.6,0.2c3.6,1.7,6.9,4.1,9.6,7c0.2,0.2,0.3,0.4,0.3,0.6c0.1,0.2,0.1,0.4,0.1,0.7l-0.9,9.9 c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.3,0.4-0.6,0.5l-6,3.2c-0.3,0.1-0.6,0.2-0.8,0.2c-0.3,0-0.6-0.1-0.8-0.3l-10.9-8 c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.2-0.2-0.5-0.2-0.7L56.2,28.5z M39,23.4c-3.6,1.7-6.8,4.1-9.6,6.9c-0.2,0.2-0.3,0.4-0.3,0.6 c-0.1,0.2-0.1,0.4-0.1,0.7l0.9,9.9c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.4,0.6,0.5l6.3,3.1c0.3,0.1,0.5,0.2,0.8,0.2 c0.3,0,0.6-0.1,0.8-0.3l10.6-7.7c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.5,0.2-0.7v-8.1c0-0.3-0.1-0.6-0.3-0.9 c-0.2-0.3-0.4-0.5-0.7-0.6l-8.7-3.7c-0.2-0.1-0.4-0.1-0.6-0.1C39.4,23.2,39.2,23.3,39,23.4z M39.8,67.1L36.3,71 c-0.2,0.2-0.4,0.4-0.7,0.4c-0.3,0.1-0.6,0.1-0.8,0l-9.6-2.2c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.5 c-1.9-3.5-3.1-7.3-3.6-11.2c0-0.2,0-0.4,0-0.6c0.1-0.2,0.2-0.4,0.3-0.6l6-6.9c0.2-0.3,0.5-0.4,0.9-0.5c0.3-0.1,0.7,0,1,0.2l6.6,3.5 c0.4,0.2,0.6,0.5,0.8,0.9l4,12.3c0.1,0.3,0.1,0.5,0,0.8C40.1,66.7,40,66.9,39.8,67.1z M60,84.5l4.8-8.1l0,0c0.2-0.3,0.2-0.6,0.2-1 c0-0.3-0.2-0.6-0.4-0.9l-3.5-3.9c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1H46.2c-0.2,0-0.4,0-0.6,0.1 c-0.2,0.1-0.4,0.2-0.5,0.4l-3.5,3.9c-0.2,0.2-0.4,0.6-0.4,0.9c0,0.3,0,0.7,0.2,1l4.8,8.1c0.1,0.2,0.3,0.4,0.5,0.5 c0.2,0.1,0.4,0.2,0.6,0.3c3.9,0.7,7.8,0.7,11.7,0c0.2,0,0.4-0.1,0.6-0.3C59.7,84.9,59.9,84.7,60,84.5z M81.9,68.5 c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.1-0.4,0.2-0.6,0.3l-9.6,2.2c-0.3,0.1-0.6,0.1-0.8,0c-0.3-0.1-0.5-0.2-0.7-0.4l-3.5-3.9 c-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3,0-0.5,0-0.8l4-12.3c0.1-0.4,0.4-0.7,0.8-0.9l6.6-3.5c0.3-0.2,0.7-0.2,1-0.2 c0.3,0.1,0.7,0.2,0.9,0.5l6,7c0.1,0.2,0.3,0.4,0.3,0.6c0.1,0.2,0.1,0.4,0.1,0.7C85,61.3,83.8,65.1,81.9,68.5L81.9,68.5z"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_shirt",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_shirt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M98.8,22.3L98.8,22.3L82.5,6.6c-4.3-4.1-10-6.4-15.9-6.4c-0.4,0.1-1.8-0.3-2.1,1.3c-1,7.4-7.1,13-14.5,13.3 c-7.4-0.3-13.6-6-14.5-13.3c-0.3-1.5-1.7-1.1-2.1-1.3c-5.9,0-11.6,2.3-15.9,6.4L1.2,22.3c-1.6,1.6-1.6,4.3,0,5.9l9.7,9.7 c1.5,1.5,3.9,1.7,5.6,0.3l5.2-4c0.9-0.7,2.2-0.5,2.9,0.4c0.3,0.4,0.4,0.8,0.4,1.3V94c0,2.3,1.9,4.2,4.2,4.2h41.7 c2.3,0,4.2-1.9,4.2-4.2V35.8c0-1.2,0.9-2.1,2.1-2.1c0.5,0,0.9,0.2,1.3,0.4l5.1,4c1.7,1.4,4.1,1.3,5.6-0.3l9.7-9.7 C100.4,26.6,100.4,23.9,98.8,22.3z"
  }))))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_shorts",
    viewBox: "0 0 100 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_shorts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M93.4,12.5c1.1,0,2.1-0.9,2.1-2.1c0,0,0-0.1,0-0.1l-0.3-6.4C95,1.7,93.2,0,91,0H9c-2.2,0-4,1.7-4.2,3.9 l-0.3,6.4c-0.1,1.1,0.8,2.1,2,2.2c0,0,0.1,0,0.1,0H93.4z M100,95.6L96,20.7c-0.1-1.1-1-2-2.1-2H6c-1.1,0-2,0.9-2.1,2L0,95.6 c-0.1,2.3,1.6,4.3,3.9,4.4c0.1,0,0.1,0,0.2,0h31.4c2.1,0,3.8-1.5,4.1-3.6L45,58.6c0.4-2.8,3-4.7,5.8-4.3c2.2,0.3,4,2.1,4.3,4.3 l5.2,37.8c0.3,2.1,2.1,3.6,4.1,3.6h31.4c2.3,0,4.2-1.9,4.2-4.2C100,95.8,100,95.7,100,95.6z"
  }))))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_socks",
    viewBox: "0 0 110 160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_socks"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16,107.5c-1.3-1-3.1-1-4.3,0.1c-11.7,11-12.3,29.3-1.3,41c5.3,5.7,12.7,9,20.5,9.2c1.6,0,3-1.1,3.3-2.8 C36.9,137.1,30,119,16,107.5z M44.2,152.6c-0.1,0.9,0.6,1.7,1.5,1.7c0.2,0,0.5,0,0.7-0.1l23.1-8.4c1.7-0.6,2.5-2.5,1.9-4.1 c0,0,0-0.1,0-0.1c-7.5-18.6,1.4-39.8,20-47.3c2.7-1.1,5.6-1.9,8.4-2.3c1.6-0.2,2.8-1.6,2.8-3.2V6.2c0-1.8-1.4-3.2-3.2-3.2H47.8 c-1.8,0-3.2,1.4-3.2,3.2v80.2c0,4.1-2.5,7.7-6.4,9.1L25.8,100c-0.8,0.3-1.3,1.2-1,2.1c0.1,0.2,0.2,0.5,0.4,0.6 C38.9,115.6,45.9,134,44.2,152.6z M78.4,128c0,4.2,1,8.3,2.9,12c0.4,0.7,1.3,1.1,2,0.8c11.6-4.1,19.3-15,19.3-27.3v-10.2 c0-0.9-0.7-1.6-1.6-1.6c-0.1,0-0.2,0-0.3,0C87.9,103.8,78.5,114.9,78.4,128z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "FBL_substitution",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M62,22.4c-5.4-1.7-11.3-1.9-16.8-0.6c-5.4,1.4-10.3,4-14.4,7.7c-4.1,3.7-7.2,8.4-9,13.6 c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.2,0.1,0.3,0.2,0.5s0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.2l8.2,1c0.4,0,0.8,0.2,1.1,0.5 c0.3,0.3,0.6,0.6,0.7,1c0.1,0.4,0.2,0.8,0.1,1.2c-0.1,0.4-0.3,0.8-0.6,1.1L17,64.9c-0.2,0.2-0.4,0.4-0.7,0.5 c-0.3,0.1-0.6,0.2-0.8,0.2c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7-0.2-0.9-0.3c-0.3-0.2-0.5-0.4-0.7-0.7L2.8,45.6c-0.2-0.4-0.3-0.8-0.3-1.2 c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.5-0.6,0.9-0.8c0.4-0.2,0.8-0.2,1.2-0.2l4.5,0.6c0.3,0,0.5,0,0.7-0.2c0.2-0.1,0.4-0.4,0.4-0.6 c2.2-7.5,6.3-14.3,11.9-19.8c5.6-5.4,12.6-9.3,20.2-11.2C50.1,9.4,58,9.7,65.3,12c7.3,2.3,13.9,6.6,19,12.4c1,1.1,1.4,2.5,1.4,3.9 c-0.1,1.4-0.7,2.8-1.8,3.7c-1.1,1-2.5,1.4-3.9,1.4c-1.4-0.1-2.8-0.7-3.7-1.8C72.3,27.3,67.4,24.1,62,22.4z M102.5,60.5 c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1,0.3c-0.1,0-0.2,0-0.3,0l-4.6-0.6c-0.3,0-0.5,0-0.7,0.2 c-0.2,0.1-0.4,0.4-0.4,0.6c-2.2,7.5-6.3,14.3-11.9,19.8c-5.6,5.4-12.6,9.3-20.2,11.2c-7.5,1.8-15.3,1.5-22.6-0.8 c-7.3-2.3-13.9-6.6-19-12.3c-0.5-0.5-0.9-1.2-1.1-1.8c-0.2-0.7-0.4-1.4-0.3-2.1c0-0.7,0.2-1.4,0.5-2.1c0.3-0.7,0.8-1.2,1.3-1.7 c0.5-0.5,1.2-0.8,1.9-1.1c0.7-0.2,1.4-0.3,2.1-0.3c0.7,0.1,1.4,0.2,2.1,0.6c0.6,0.3,1.2,0.8,1.7,1.3c3.8,4.3,8.7,7.5,14.1,9.2 c5.4,1.7,11.3,1.9,16.8,0.6c5.4-1.4,10.3-4,14.4-7.7c4.1-3.7,7.2-8.4,9-13.6c0.1-0.2,0.1-0.3,0.1-0.5c0-0.2-0.1-0.3-0.2-0.5 c-0.1-0.1-0.2-0.3-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.2l-8-1c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.6-0.6-0.7-1c-0.1-0.4-0.2-0.8-0.1-1.2 c0.1-0.4,0.3-0.8,0.6-1l15-15.7c0.2-0.2,0.5-0.4,0.8-0.6c0.3-0.1,0.7-0.2,1-0.1c0.3,0,0.7,0.2,0.9,0.3c0.3,0.2,0.5,0.4,0.7,0.7 l10.9,18.8C102.4,59.7,102.5,60.1,102.5,60.5z"
  })), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "stopwatch",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "retweet",
    viewBox: "0 0 576 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "id-card-clip",
    viewBox: "0 0 576 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right-arrow-left",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "baseball-bat-ball",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "baseball",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "hockeypuck",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "football",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "caretup",
    viewBox: "0 0 320 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "caretdown",
    viewBox: "0 0 320 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "expulsion",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE000"
    },
    d: "M63.3,95.9H9.4c-2.2,0-4.1-1.8-4.1-4.1V11.3c0-2.2,1.8-4.1,4.1-4.1h53.9c2.2,0,4.1,1.8,4.1,4.1v80.5 C67.4,94.1,65.6,95.9,63.3,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80000"
    },
    d: "M69.1,102.6L17.4,87c-2.1-0.6-3.4-2.9-2.7-5.1L38,4.8c0.6-2.1,2.9-3.4,5.1-2.7l51.6,15.6 c2.1,0.6,3.4,2.9,2.7,5.1L74.1,99.8C73.5,102,71.2,103.2,69.1,102.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "double_yellow",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE000"
    },
    d: "M63.3,95.9H9.4c-2.2,0-4.1-1.8-4.1-4.1V11.3c0-2.2,1.8-4.1,4.1-4.1h53.9c2.2,0,4.1,1.8,4.1,4.1v80.5         C67.4,94.1,65.6,95.9,63.3,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE000"
    },
    d: "M69.1,102.6L17.4,87c-2.1-0.6-3.4-2.9-2.7-5.1L38,4.8c0.6-2.1,2.9-3.4,5.1-2.7l51.6,15.6         c2.1,0.6,3.4,2.9,2.7,5.1L74.1,99.8C73.5,102,71.2,103.2,69.1,102.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sustitution",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB333B"
    },
    d: "M62,22.4c-5.4-1.7-11.3-1.9-16.8-0.6c-5.4,1.4-10.3,4-14.4,7.7s-7.2,8.4-9,13.6c-0.1,0.2-0.1,0.3-0.1,0.5 s0.1,0.3,0.2,0.5s0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.2l8.2,1c0.4,0,0.8,0.2,1.1,0.5s0.6,0.6,0.7,1s0.2,0.8,0.1,1.2 c-0.1,0.4-0.3,0.8-0.6,1.1L17,64.9c-0.2,0.2-0.4,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-0.8,0.2c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7-0.2-0.9-0.3 c-0.3-0.2-0.5-0.4-0.7-0.7l-10.8-19c-0.2-0.4-0.3-0.8-0.3-1.2s0.1-0.8,0.4-1.1c0.2-0.3,0.5-0.6,0.9-0.8s0.8-0.2,1.2-0.2l4.5,0.6 c0.3,0,0.5,0,0.7-0.2c0.2-0.1,0.4-0.4,0.4-0.6c2.2-7.5,6.3-14.3,11.9-19.8c5.6-5.4,12.6-9.3,20.2-11.2C50.1,9.4,58,9.7,65.3,12 s13.9,6.6,19,12.4c1,1.1,1.4,2.5,1.4,3.9c-0.1,1.4-0.7,2.8-1.8,3.7c-1.1,1-2.5,1.4-3.9,1.4c-1.4-0.1-2.8-0.7-3.7-1.8 C72.3,27.3,67.4,24.1,62,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0A9504"
    },
    d: "M102.5,60.5c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.5,0.5-0.8,0.7s-0.7,0.3-1,0.3c-0.1,0-0.2,0-0.3,0L95.4,62 c-0.3,0-0.5,0-0.7,0.2c-0.2,0.1-0.4,0.4-0.4,0.6c-2.2,7.5-6.3,14.3-11.9,19.8c-5.6,5.4-12.6,9.3-20.2,11.2 c-7.5,1.8-15.3,1.5-22.6-0.8s-13.9-6.6-19-12.3c-0.5-0.5-0.9-1.2-1.1-1.8c-0.2-0.7-0.4-1.4-0.3-2.1c0-0.7,0.2-1.4,0.5-2.1 s0.8-1.2,1.3-1.7s1.2-0.8,1.9-1.1c0.7-0.2,1.4-0.3,2.1-0.3c0.7,0.1,1.4,0.2,2.1,0.6c0.6,0.3,1.2,0.8,1.7,1.3 c3.8,4.3,8.7,7.5,14.1,9.2s11.3,1.9,16.8,0.6c5.4-1.4,10.3-4,14.4-7.7s7.2-8.4,9-13.6c0.1-0.2,0.1-0.3,0.1-0.5S83.1,61.2,83,61 c-0.1-0.1-0.2-0.3-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.2l-8-1c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.6-0.6-0.7-1s-0.2-0.8-0.1-1.2 s0.3-0.8,0.6-1l15-15.7c0.2-0.2,0.5-0.4,0.8-0.6c0.3-0.1,0.7-0.2,1-0.1c0.3,0,0.7,0.2,0.9,0.3c0.3,0.2,0.5,0.4,0.7,0.7l10.9,18.8 C102.4,59.7,102.5,60.1,102.5,60.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "substitution2",
    viewBox: "0 0 105 105"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB333B"
    },
    d: "M3.2,52.3c0-2.8,0.8-5.3,2-6.6L41.6,3.8c1.2-1.5,2.7-1.5,4,0c1.2,1.5,2,4,2,6.8v83.7c0,2.8-0.8,5.3-2,6.8 s-2.7,1.3-4,0L5.3,59.1C4,57.6,3.2,55.1,3.2,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A9504"
    },
    d: "M101.8,52.7c0,2.8-0.8,5.3-2,6.6l-36.5,41.9c-1.2,1.5-2.7,1.5-4,0c-1.3-1.5-2-3.8-2-6.6V10.8 c0-2.8,0.8-5.3,2-6.8c1.2-1.5,2.7-1.3,4,0l36.5,41.9C101,47.4,101.8,49.9,101.8,52.7z"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "WRS-arrow-down",
    viewBox: "0 0 384 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 32 33",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 22.3494L6.035 22.2944L15 27.9797L15 2.98437L17 2.98437L17 27.9565L25.965 22.2344L26 22.2944L26 24.5944L15.99 30.9844L6 24.6494L6 22.3494Z",
    fill: "black"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "WRS-arrow-up",
    viewBox: "0 0 384 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up",
    viewBox: "0 0 32 33",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 11.6194L25.965 11.6744L17 5.98903L17 30.9844L15 30.9844L15 6.01222L6.035 11.7344L6 11.6744L6 9.37437L16.01 2.98438L26 9.31937L26 11.6194Z",
    fill: "black"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "WRS-arrows-up-down",
    viewBox: "0 0 320 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrows-up-down",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_949_2220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.965 8.69L26 8.635L26 6.335L16.01 -4.36677e-07L6 6.39L6 8.69L6.035 8.75L15 3.02785L15 26.9953L6.035 21.31L6 21.365L6 23.665L15.99 30L26 23.61L26 21.31L25.965 21.25L17 26.9722L17 3.00466L25.965 8.69Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_2220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "caretleft",
    viewBox: "0 0 256 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "caretright",
    viewBox: "0 0 256 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "green-card",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28A745"
    },
    d: "M388.7,474.2H123.2c-11,0-20-9-20-20V57.7c0-11,9-20,20-20h265.5c11,0,20,9,20,20v396.5 C408.7,465.3,399.8,474.2,388.7,474.2z"
  })), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-cross",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434,511.6H80.2c-43.2,0-78.3-35.1-78.3-78.3V79.6C1.9,36.4,37,1.3,80.2,1.3H434c43.2,0,78.3,35.1,78.3,78.3v353.8 C512.2,476.5,477.1,511.6,434,511.6z M80.2,16.3c-34.9,0-63.3,28.4-63.3,63.3v353.8c0,34.9,28.4,63.3,63.3,63.3H434 c34.9,0,63.3-28.4,63.3-63.3V79.6c0-34.9-28.4-63.3-63.3-63.3H80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8,74.2c21.2-21.2,55.4-21.2,76.4,0l105.9,105.9L362.9,74.2c21.2-21.2,55.4-21.2,76.4,0c21,21.2,21.2,55.4,0,76.4 L333.4,256.5l105.9,105.9c21.2,21.2,21.2,55.4,0,76.4c-21.2,21-55.4,21.2-76.4,0L257.1,332.9L151.2,438.7 c-21.2,21.2-55.4,21.2-76.4,0s-21.2-55.4,0-76.4l105.9-105.9L74.8,150.6C53.6,129.4,53.6,95.2,74.8,74.2z"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 5.15623L19.901 18.8437H4.09853L11.9998 5.15623ZM11.9998 2.91748C11.7298 2.91748 11.456 3.09748 11.2498 3.45373L2.24978 19.0425C1.83728 19.7587 2.17478 20.34 2.99978 20.34H20.9998C21.8248 20.34 22.1623 19.755 21.7498 19.0425L12.7498 3.45748C12.5435 3.10123 12.2698 2.92123 11.9998 2.92123V2.91748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 17.25C11.5608 17.25 11.2271 16.9312 11.2271 16.5C11.2271 16.0688 11.5533 15.75 11.9996 15.75C12.4458 15.75 12.7721 16.0688 12.7721 16.5C12.7721 16.9312 12.4458 17.25 11.9996 17.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.79102H12.75L12.645 14.291H11.355L11.25 9.79102Z",
    fill: "black"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-border",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M39.5,101.4c0-34.1,27.7-61.9,61.9-61.9h309.3c34.1,0,61.9,27.7,61.9,61.9v309.3c0,34.1-27.7,61.9-61.9,61.9 H101.4c-34.1,0-61.9-27.7-61.9-61.9V101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,477.6H101.4c-36.9,0-66.9-30-66.9-66.9V101.4c0-36.9,30-66.9,66.9-66.9h309.3c36.9,0,66.9,30,66.9,66.9v309.3 C477.6,447.6,447.6,477.6,410.7,477.6z M101.4,44.5C70,44.5,44.5,70,44.5,101.4v309.3c0,31.4,25.5,56.9,56.9,56.9h309.3 c31.4,0,56.9-25.5,56.9-56.9V101.4c0-31.4-25.5-56.9-56.9-56.9H101.4z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "green",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_00000088094787741936841490000008345163261077846408_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28A745"
    },
    d: "M51,88.6c0-34.1,27.7-61.9,61.9-61.9h309.3c34.1,0,61.9,27.7,61.9,61.9v309.3c0,34.1-27.7,61.9-61.9,61.9 H112.9c-34.1,0-61.9-27.7-61.9-61.9V88.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 293.2,
    x2: 51,
    y2: 293.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 268.9,
    x2: 51,
    y2: 268.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 220.3,
    x2: 51,
    y2: 220.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 196,
    x2: 51,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 171.8,
    x2: 51,
    y2: 171.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 317.5,
    x2: 51,
    y2: 317.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 244.6,
    x2: 51,
    y2: 244.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 147.5,
    x2: 51,
    y2: 147.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 123.2,
    x2: 51,
    y2: 123.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 482.5,
    y1: 74.6,
    x2: 52.6,
    y2: 74.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 470.9,
    y1: 50.4,
    x2: 64.2,
    y2: 50.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 98.9,
    x2: 51,
    y2: 98.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 468.5,
    y1: 438.9,
    x2: 66.5,
    y2: 438.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 481.8,
    y1: 414.6,
    x2: 53.3,
    y2: 414.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 366,
    x2: 51,
    y2: 366.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 341.8,
    x2: 51,
    y2: 341.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 484.1,
    y1: 390.4,
    x2: 51,
    y2: 390.4
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "red",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    style: {
      fill: "#D80000"
    },
    width: 430,
    height: 430
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476,476H36V36h440V476z M46,466h420V46H46V466z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 103.1,
    r: 37.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.8,
    cy: 103.1,
    r: 37.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 103.1,
    r: 37.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 255.6,
    r: 37.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.8,
    cy: 255.6,
    r: 37.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 255.6,
    r: 37.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 408.1,
    r: 37.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.8,
    cy: 408.1,
    r: 37.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 408.1,
    r: 37.5
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "blue",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blue"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0000CC"
    },
    cx: 253.5,
    cy: 255.5,
    r: 245
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 253.5,
    cy: 255.5,
    r: 235
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0000CC"
    },
    cx: 253.5,
    cy: 255.5,
    r: 225
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000121995266294582320970000000221810406492832390_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.4,
    y: 68.1,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -144.5042 238.2369)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 451
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.2,
    y: -3.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -75.4616 265.8309)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 455
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.3,
    y: -20.1,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -41.9156 281.8328)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 423.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.9,
    y: -26.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.8703 294.4106)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 363.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.1,
    y: -7.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 27.1574 309.414)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 258.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 280.1,
    transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -247.6083 195.756)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 233.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 187.5,
    transform: "matrix(0.7073 -0.707 0.707 0.7073 -212.7056 208.6122)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 347.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 122.3,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -179.2327 224.9397)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 413.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.1,
    y: 26.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -109.9235 251.8738)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10,
    height: 463.6
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "white",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46,85.1c0-34.9,28.3-63.3,63.3-63.3h316.4c34.9,0,63.3,28.3,63.3,63.3v316.4c0,34.9-28.3,63.3-63.3,63.3H109.3 c-34.9,0-63.3-28.3-63.3-63.3V85.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M51,88.6c0-34.1,27.7-61.9,61.9-61.9h309.3c34.1,0,61.9,27.7,61.9,61.9v309.3c0,34.1-27.7,61.9-61.9,61.9 H112.9c-34.1,0-61.9-27.7-61.9-61.9V88.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 123.2,
    y1: 459.9,
    x2: 484,
    y2: 99
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 92.3,
    y1: 456.4,
    x2: 480.5,
    y2: 68.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 56.5,
    y1: 423.6,
    x2: 447.7,
    y2: 32.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 394.8,
    x2: 418.9,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 360.4,
    x2: 384.6,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 326.1,
    x2: 350.2,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 291.7,
    x2: 315.9,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 257.4,
    x2: 281.5,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 223,
    x2: 247.2,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 188.7,
    x2: 212.8,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 154.3,
    x2: 178.5,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    d: "M43,162.3"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 50.9,
    y1: 120,
    x2: 144.2,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    d: "M43,128"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 51,
    y1: 85.6,
    x2: 109.7,
    y2: 26.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    d: "M43,93.6"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 433.3,
    y1: 458.9,
    x2: 483,
    y2: 409.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 398,
    y1: 459.9,
    x2: 484,
    y2: 373.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 363.6,
    y1: 459.9,
    x2: 484,
    y2: 339.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 329.3,
    y1: 459.9,
    x2: 484,
    y2: 305.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 294.9,
    y1: 459.9,
    x2: 484,
    y2: 270.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 260.6,
    y1: 459.9,
    x2: 484,
    y2: 236.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 226.2,
    y1: 459.9,
    x2: 484,
    y2: 202.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 191.9,
    y1: 459.9,
    x2: 484,
    y2: 167.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 157.5,
    y1: 459.9,
    x2: 484,
    y2: 133.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 70.9,
    y1: 443.5,
    x2: 467.6,
    y2: 46.8
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "yellow",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    style: {
      fill: "#FFD400"
    },
    width: 430,
    height: 430
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hbl_ball",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 50,
    cy: 50,
    r: 47.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "51.1,15.5 32.8,19.6 25.7,36 37.6,49.6 55.4,46.2 61.3,29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "55.4,46.2 37.6,49.6 31.5,65.8 42.5,79.7 62.5,76.7 67.1,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "62.5,76.7 42.5,79.7 38.9,88.4 53.1,97.1 64.4,95.1 70.3,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "61.3,29 55.4,46.2 67.1,58.8 82.4,50.9 78.9,32.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "25.7,36 12.4,46.2 16.2,63.5 31.5,65.8 37.6,49.6  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 51.1,
    y1: 15.5,
    x2: 60.7,
    y2: 3.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 78.9,
    y1: 32.1,
    x2: 86.8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 82.4,
    y1: 50.9,
    x2: 95.9,
    y2: 62.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 70.3,
    y1: 83,
    x2: 88.9,
    y2: 77.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 38.9,
    y1: 88.4,
    x2: 21.6,
    y2: 88.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 16.2,
    y1: 63.5,
    x2: 10.5,
    y2: 76.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 12.4,
    y1: 45.9,
    x2: 3.3,
    y2: 41.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#010202",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 32.8,
    y1: 19.6,
    x2: 24,
    y2: 10.2
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "protest",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80000"
    },
    d: "M403.9,467.2c-3.7,4.3-9.1,7-15.2,7H123.2c-11,0-20-9-20-20V57.7c0-5.9,2.6-11.2,6.6-14.8L403.9,467.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M408.7,57.7v396.5c0,5-1.8,9.6-4.8,13l-294-424.4c3.5-3.2,8.2-5.2,13.4-5.2h265.5 C399.7,37.7,408.7,46.7,408.7,57.7z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 10,
      strokeMiterlimit: 10
    },
    x1: 408.7,
    y1: 474.2,
    x2: 403.9,
    y2: 467.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 10,
      strokeMiterlimit: 10
    },
    x1: 109.8,
    y1: 42.9,
    x2: 106.2,
    y2: 37.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeMiterlimit: 10
    },
    d: "M408.7,57.7v396.5c0,11.1-8.9,20-20,20H123.2c-11,0-20-9-20-20V57.7c0-11,9-20,20-20h265.5 C399.7,37.7,408.7,46.7,408.7,57.7z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "turn-up",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.1,352c-17.7,0-32-14.3-32-32V153.3l73.3,73.4c12.5,12.5,32.8,12.5,45.3,0s12.5-32.8,0-45.3l-128-128 c-12.5-12.5-32.8-12.5-45.3,0l-128,128c-12.5,12.5-12.5,32.8,0,45.3s32.8,12.5,45.3,0l73.4-73.4V320c0,53,43,96,96,96h216 c17.7,0,32-14.3,32-32s-14.3-32-32-32H248.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteIcons);
export default __webpack_public_path__ + "static/media/SpriteIcons.3df7d6b253726d0e76530a19f8a91906.svg";
export { ForwardRef as ReactComponent };